export default {
  none: "None",
  badge: {
    new: "NEW",
  },
  contextTag: {
    add: "Add tag",
  },
  nav: {
    menu: "Menu",
    mainNav: "Navigation",
    home: "Home",
    dashboard: "Dashboard",
    orders: "Orders",
    products: "Products",
    archive: "Archive",
    settings: "Settings",
    language: "Language",
    theme: "Theme",
    more: "More",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit Fullscreen",
    workspaces: "Workspaces",
    configuration: "Configuration",
    personalSettings: "Personal Settings",
    systemConfig: "System Configuration",
    deliverySessions: "Delivery Sessions",
    delivery: "Delivery",
    showGuide: "Help & Guide",
    customers: "Customers",
  },
  settings: {
    title: "Settings",
    pageDescription: "Configure your workspace preferences",
    contextTags: "Context Tags",
    contextTagsDescription: "Define custom tags to classify your orders (e.g., Repair, Exchange, Pickup). These help organize orders without affecting delivery workflow.",
    addContextPlaceholder: "Add context (e.g., Repair)",
    contextsUsed: "contexts used",
    noContexts: "No context tags defined",
    addFirstContext: "Add your first context tag above",
    saved: "Settings saved",
    saveFailed: "Settings couldn't be saved. Let's try again.",
    saveChanges: "Save Changes",
    noChanges: "No unsaved changes",
    maxContextsReached: "Maximum 7 contexts allowed",
    duplicateContext: "This context already exists",
    courierQuickActions: "Courier Quick Actions",
    courierQuickActionsDescription: "Actions couriers can use to create new orders during delivery (e.g., returns, repairs, extra pickups)",
    addActionPlaceholder: "Add action (e.g., Return)",
    actionsUsed: "actions configured",
    actionsEnabled: "actions enabled",
    noActions: "No quick actions configured",
    addFirstAction: "Add your first quick action above",
    maxActionsReached: "Maximum 10 actions allowed",
    duplicateAction: "This action already exists",
    enableAction: "Enable action",
    disableAction: "Disable action",
    externalOrder: {
      title: "External Order Intake",
      description: "Accept customer orders through a public link. Customers can place orders directly without logging in.",
      productMode: "Product Selection",
      selectFromProducts: "Select from Products",
      customProduct: "Custom Product",
      selectProduct: "Select a Product",
      noProducts: "No products available",
      productName: "Product Name",
      productNamePlaceholder: "e.g. Fresh Eggs",
      productPrice: "Price per Unit (₾)",
      productPricePlaceholder: "e.g. 0.50",
      productUnit: "Unit Type",
      category: "Order Category",
      selectCategory: "Select a Category",
      publicLink: "Public Order Link",
      linkCopied: "Link copied!",
      regenerateLink: "Regenerate Link",
      regenerateConfirm: "Are you sure you want to regenerate the link? The old link will stop working and you'll need to share the new one.",
      linkProtectedHint: "This link is permanent. Use the refresh button only if you need a new URL.",
      businessPhone: "Business Phone",
      businessPhoneHint: "Shown to customers for questions",
      deliveryNote: "Delivery Note",
      deliveryNotePlaceholder: "e.g. Free delivery in Tbilisi",
      minQuantity: "Minimum Quantity",
      save: "Save Settings",
      selectProductFirst: "Please enter product name and price",
    },
    orderId: {
      title: "Order ID Format",
      description: "Configure how order numbers are automatically generated",
      mode: "Generation Mode",
      unifiedFormat: "Unified Format (same for all)",
      perSourceFormat: "Per-Source Prefixes",
      prefix: "Prefix",
      separator: "Separator",
      noSeparator: "None",
      dateFormat: "Date Format",
      noDate: "No Date",
      sequenceLength: "Sequence Length",
      digits: "digits",
      preview: "Preview",
      sourcePrefixes: "Source Prefixes",
      manualPrefix: "Manual",
      externalPrefix: "External",
      aiPrefix: "AI/Smart",
      courierPrefix: "Courier",
      autoGenerateHint: "Leave order number blank when creating orders to use auto-generation",
    },
    dashboardPreferences: "Dashboard Preferences",
    showLivePulse: "Show Live Activity Console",
    showLivePulseDesc: "Real-time feed of order activity below the greeting",
    enablePulseSound: "Alert Sound for Critical Events",
    enablePulseSoundDesc: "Play a subtle sound when delivery failures or rejections occur",
    appInstallation: {
      title: "App Installation",
      description: "Install OrderFlow as an app for faster access and offline support",
      statusInstalled: "Already installed",
      statusNotInstalled: "Not installed",
      statusCanInstall: "Ready to install",
      installButton: "Install",
      installButtonLong: "Install App",
      iosTitle: "Install on iOS",
      iosStep1: "Tap the Share button (□↑) at the bottom of Safari",
      iosStep2: "Scroll down and tap \"Add to Home Screen\"",
      iosStep3: "Tap \"Add\" in the top right corner",
      androidTitle: "Install on Android",
      androidStep1: "Tap the menu button (⋮) in your browser",
      androidStep2: "Tap \"Add to Home screen\" or \"Install app\"",
      androidStep3: "Tap \"Add\" to confirm",
      desktopTitle: "Install App",
      desktopStep1: "Click the install icon (⊕) in your browser's address bar",
      desktopStep2: "Or click menu (⋮) and select \"Install OrderFlow\"",
      desktopStep3: "Follow the prompts to complete installation",
    },
    branding: {
      title: "Public Page Branding",
      description: "Personalize your public order page so customers recognize your brand",
      logo: "Logo",
      logoHint: "Displayed in the header of your public page",
      uploadLogo: "Upload Logo",
      replaceLogo: "Replace",
      removeLogo: "Remove",
      brandColor: "Brand Color",
      brandColorHint: "Applied to buttons and accents on your public page",
      tagline: "Tagline",
      taglinePlaceholder: "e.g. Natural mountain honey with next-day delivery",
      taglineHint: "Short message under your business name",
      introText: "About Your Business",
      introTextPlaceholder: "e.g. We produce natural honey collected from the forests of Adjara. Orders placed today are delivered tomorrow.",
      introTextHint: "Brief description shown to customers",
      contactLinks: "Contact Links",
      contactLinksHint: "Let customers reach you through other channels",
      addLink: "Add Link",
      removeLink: "Remove",
      linkType: "Type",
      linkValue: "Link / Number",
      phone: "Phone",
      messenger: "Messenger",
      instagram: "Instagram",
      facebook: "Facebook",
      maxLinks: "Maximum 4 contact links",
      charsRemaining: "characters remaining",
    },
  },
  livePulse: {
    newOrder: "New order received",
    statusChange: "→ {{status}}",
    acknowledged: "acknowledged",
    cantTake: "Can't take",
    deliveryFailed: "Delivery failed",
    delivered: "delivered",
    received: "received",
    created: "created",
    waitingForActivity: "Waiting for activity...",
    statusNew: "→ New",
    statusProcessing: "→ Processing",
    statusReady: "→ Ready",
    statusOutForDelivery: "→ Out for Delivery",
    statusCancelled: "→ Cancelled",
    statusAwaitingPayment: "→ Awaiting Payment",
    outForDelivery: "Out for delivery",
    addressUpdated: "Delivery address updated",
    assignedToSession: "Assigned to delivery session",
    removedFromSession: "Removed from session",
    paymentReceived: "Payment received",
    orderReceived: "Order received",
    orderEdited: "Order details updated",
    retryDelivery: "Delivery retry initiated",
  },
  readiness: {
    prepared: "Prepared",
    needsAction: "Needs action",
    preparedTooltip: "All orders are prepared and assigned to courier.",
    needsActionPrefix: "Needs action",
    // Status-based labels (not acknowledgement-based)
    preparationLabel: "need preparation",
    dispatchLabel: "ready for dispatch",
    issuesLabel: "delivery issues",
  },
  roles: {
    manager: "Manager",
    courier: "Courier",
    system: "System",
  },
  theme: {
    switchToDark: "Switch to dark mode",
    switchToLight: "Switch to light mode",
    eveningActive: "Evening warmth active ☀️→🌙",
    nightModeAuto: "Night mode (auto-enabled for eye comfort)",
    nightModeOverride: "You switched to light mode - tap to return to dark",
  },
  fullscreen: {
    enter: "Full screen",
    exit: "Exit full screen",
    addToHomeScreen: "Add to Home Screen for fullscreen",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all read",
    empty: "No activity yet",
    soundOn: "Turn on sound",
    soundOff: "Turn off sound",
    rollingWindow: "Showing last 2 days",
  },
  recentActivity: {
    title: "Recent Activity",
    seeAll: "See all",
    empty: "No activity yet",
    today: "Today",
    yesterday: "Yesterday",
    earlier: "Earlier",
    rollingWindow: "Showing last 2 days",
  },
  common: {
    back: "Back",
    signOut: "Sign Out",
    dashboard: "Dashboard",
    loading: "Loading...",
    save: "Save",
    retrySave: "Retry Save",
    offlineBanner: "You're offline — changes won't save until connection is restored.",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search",
    filter: "Filter",
    export: "Export",
    add: "Add",
    all: "All",
    yes: "Yes",
    no: "No",
    close: "Close",
    at: "at",
    from: "From",
    to: "To",
    of: "of",
    next: "Next",
    success: "Success",
    error: "Error",
    more: "More",
    none: "None",
    saving: "Saving...",
    disabled: "Disabled",
    actions: "Actions",
    order: "order",
    orders: "orders",
    update: "Update",
    showLess: "Show less",
    discardChanges: {
      title: "Discard changes?",
      description: "You have unsaved changes that will be lost.",
      keepEditing: "Keep editing",
      discard: "Discard",
    },
  },
  session: {
    column: "Delivery",
    unassigned: "Unassigned",
    noActiveSessions: "No active deliveries",
    notReadyTooltip: "Order must be Ready before it can be dispatched",
    lockedTooltip: "Order is locked to this delivery",
    assignToSession: "Assign to Delivery",
    unassign: "Unassign",
    confirmReassign: {
      title: "Reassign Order",
      description: "Select a delivery to assign this order to",
      confirm: "Reassign",
    },
    assignSuccess: "Order assigned to delivery",
    unassignSuccess: "Order removed from delivery",
    errors: {
      locked: "Order is locked — already marked delivered in an active session",
      sessionInactive: "This delivery session is not active",
      sessionExpired: "This delivery session has expired",
      sessionNotFound: "Delivery session not found",
      orderNotReady: "Order must be Ready before assigning to a session",
      generic: "Could not assign order to session",
      networkError: "Network error — please check your connection and try again",
    },
  },
  statusControl: {
    assignFirst: "Assign to session first",
    assignFirstDescription: "This order needs to be in a dispatch session before marking as delivered",
    overrideTitle: "Confirm status change",
    overrideMessage: "This order already has a delivery status. Updating it will override the current state.",
    overrideConfirm: "Confirm",
    overrideStatus: "Override status",
    transitionBlocked: "This status change is not allowed",
    cancelPaidTitle: "Cancel paid order?",
    cancelPaidMessage: "This order has a value of {{amount}}₾. Are you sure you want to cancel it? This action should only be done if the payment has been refunded.",
    cancelPaidConfirm: "Yes, Cancel Order",
  },
  auth: {
    signIn: "Sign In",
    signOut: "Sign Out",
    signOutSuccess: "Signed out successfully",
    logoutConfirm: {
      title: "Sign Out",
      description: "Are you sure you want to sign out? You will need to sign in again to access your orders.",
      confirm: "Sign Out",
    },
    email: "Email",
    password: "Password",
    welcomeBack: "Welcome back!",
    signInPrompt: "Sign in to access the Order Management System",
    signingIn: "Signing in...",
    success: "Welcome back!",
    error: "Invalid credentials",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset Password",
    resetPasswordPrompt: "Enter your email to receive a password reset link",
    sendResetLink: "Send Reset Link",
    sendingResetLink: "Sending...",
    resetLinkSent: "Password reset link sent! Check your email.",
    backToSignIn: "Back to sign in",
    tokenExpired: "Password Reset Link Expired",
    tokenExpiredDescription:
      "This link has expired or has already been used. Please use 'Forgot Password?' below to request a new link, or contact admin to resend your welcome email.",
    recoveryError: "Error",
    setNewPassword: "Set New Password",
    setPasswordPrompt: "Enter your new password below",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    setPassword: "Set Password",
    settingPassword: "Setting password...",
    passwordsDoNotMatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and a digit",
    passwordUpdated: "Password updated successfully! You can now sign in.",
    cancelPasswordReset: "Cancel Password Reset",
    sending: "Sending...",
    passwordResetEmailSent: "Password reset email sent! Check your inbox.",
    passwordResetFailed: "Password reset email couldn't be sent. Let's try again.",
    tryForgotPassword: "Wrong password? Use 'Forgot Password' to reset or set your password.",
    magicLinkSent: "Login link sent!",
    checkEmailForLink: "Check your email for a login link.",
    placeholders: {
      email: "manager@example.com",
      password: "••••••••",
      newPassword: "Enter new password",
      confirmPassword: "Confirm new password",
    },
    madeIn: "Made in Georgia",
    noAccount: "Don't have an account?",
    requestAccess: "Request Access",
    signUp: "Sign Up",
    haveAccount: "Already have an account?",
    modalTitle: "Welcome to OrderFlow",
    modalDescription: "Sign in to manage your orders",
  },
  orders: {
    title: "Order Management System",
    subtitle: "Manage orders from Facebook Messenger, Viber, WhatsApp, and Telegram",
    ordersLabel: "Orders",
    groups: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      older: "Older",
      ordersCount: "{{count}} orders",
      ordersCountSingular: "{{count}} order",
      noOrders: "No orders in this period",
    },
    kpi: {
      today: "Today",
      toProcess: "To Process",
      revenue: "Revenue",
      newCustomers: "New Customers",
      returningCustomers: "Returning",
      sectionTitle: "Today's Snapshot",
      deliveredToday: "Delivered Today",
      issues: "Issues",
      yesterday: "yesterday",
      ordersLabel: "orders",
    },
    welcome: {
      morning: "Good morning",
      afternoon: "Good afternoon",
      evening: "Good evening",
    },
    encouragement: {
      fresh: "Fresh start! Ready to process orders?",
      good: "Good start! Keep it going",
      great: "Great progress today!",
      incredible: "Incredible day! You're crushing it",
    },
    singleOrder: "Single Order",
    bulkUpload: "Bulk Upload",
    browseAll: "Browse order history",
    ordersFound: "{{count}} order found",
    ordersFoundPlural: "{{count}} orders found",
    showing: "Showing",
    perPage: "per page",
    exportWord: "Export Word (Raw)",
    exportingWord: "Exporting Word...",
    exportExcel: "Export to Excel",
    showGuide: "Show Guide",
    exporting: "Exporting...",
    exportSelected: "Export Selected (Excel)",
    exportSelectedWord: "Export Selected (Word)",
    exportAllExcel: "Export all to Excel",
    exportAllWord: "Export all to Word",
    sectionActions: "Section actions",
    columnsLabel: "Columns",
    wordExportConfig: {
      title: "Export to Word - Configure Stickers",
      description: "Customize the delivery sticker content and export scope",
      scope: {
        title: "Export Scope",
        selected: "Selected orders only",
        selectedCount: "{{count}} selected",
        page: "Current page only",
        pageCount: "{{count}} orders",
        all: "All filtered orders",
        allCount: "{{count}} orders",
      },
      fields: {
        title: "Fields to Include",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        orderNumber: "Order Number",
        customerName: "Customer Name",
        phone: "Phone Number",
        address: "Delivery Address",
        products: "Products",
        price: "Total Price",
        date: "Order Date",
        comments: "Comments",
        csrName: "CSR Name",
      },
      stickerOptions: {
        title: "Sticker Options",
        includeEmojis: "Include emojis (🌍, 📱, 💸, 👤)",
        includeHeader: "Include header on each sticker",
        includeFooter: "Include footer on each sticker",
      },
      buttons: {
        cancel: "Cancel",
        export: "Export to Word",
      },
    },
    statusUpdated: "Status Updated",
    statusUpdatedToNew: "Order is now ready to process",
    paymentConfirmed: "Payment confirmed",
    markAsPaid: "Mark as Paid",
    autoGenerateHint: "Leave blank to auto-generate:",
    addOrder: "Add Order",
    viewOrder: "View Details",
    deleteOrder: "Delete Order",
    confirmOrderNumberChange: "Confirm Order Number Change",
    confirmOrderNumberChangeDesc: "Changing the order number may affect tracking and invoices. Are you sure you want to change it?",
    noOrders: "No orders found",
    noOrdersDesc: "Try adjusting your filters or add a new order to get started.",
    noActiveOrders: "No active orders",
    noActiveOrdersDesc: "Create a new order or restore from archive",
    noResults: "No orders match your filters",
    noResultsDesc:
      "Try adjusting your search terms or filters to see more results, or clear all filters to view all orders.",
    selected: "selected",
    bulkEdit: "Bulk Edit",
    bulkEditTitle: "Bulk Edit Orders",
    bulkEditDesc: "Update {{count}} selected order(s). Leave fields empty to keep existing values.",
    archive: "Archive",
    archiving: "Archiving...",
    archiveOrders: "Archive Orders",
    archiveConfirm: "Archive {{count}} order(s)?",
    archiveConfirmDesc: "These orders will be moved to the archive. You can restore them later from the Archive page.",
    restore: "Restore",
    processing: "Processing",
    deletePermanently: "Delete Permanently",
    deleteConfirm: "Permanently Delete {{count}} Order(s)?",
    deleteConfirmTitle: "Permanently Delete Orders?",
    deleteConfirmDesc:
      "This action cannot be undone. This will permanently delete the selected orders and remove all associated data.",
    deleteConfirmText: "Type DELETE to confirm:",
    deleteTypePlaceholder: "Type DELETE here",
    deleteSingleTitle: "Delete Order?",
    deleteSingleDesc: "This action cannot be undone. This will permanently delete this order.",
    deleteSuccess: "Order deleted successfully",
    keepExisting: "Keep existing",
    mixedStatuses: "Mixed statuses — no common transitions",
    noChanges: "No changes",
    selectAtLeastOne: "Please select at least one field to update",
    updating: "Updating...",
    updateOrders: "Update Orders",
    backToOrders: "Back to Orders",
    archivedOrders: "archived order(s)",
    table: {
      order: "Order",
      orderNumber: "Order #",
      customer: "Customer",
      phone: "Phone",
      products: "Products",
      address: "Address",
      price: "Price",
      category: "Category",
      status: "Status",
      source: "Source",
      date: "Date",
      comments: "Notes",
      actions: "Actions",
      density: "Density",
      columns: "Columns",
      session: "Session",
    },
    tableControls: {
      densitySettings: "Table density settings",
      columnSettings: "Column visibility settings",
      comfortable: "Comfortable",
      compact: "Compact",
      cozy: "Cozy",
      showAll: "Show All",
      viewDetails: "View Details",
      actionsFor: "Actions for order",
    },
    filters: {
      searchPlaceholder: "Search by customer name, phone, or order number...",
      searchShort: "Search orders...",
      searchOrder: "Search Order",
      searchHelp: "Searchable: Order ID, Customer Name, Phone, Product Names, Notes",
      status: "Status",
      source: "Source",
      category: "Category",
      clearAll: "Clear All Filters",
      openFilters: "Open Filters",
      title: "Filters",
      sourceHelp: "Where the order came from (Viber, WhatsApp, etc.)",
      categoryHelp: "Product category (e.g., Furniture, Electronics)",
    },
    sort: {
      sortBy: "Sort by",
      dateNewest: "Date (Newest First)",
      dateOldest: "Date (Oldest First)",
      customerAZ: "Customer Name (A-Z)",
      customerZA: "Customer Name (Z-A)",
      priceHighLow: "Price (High to Low)",
      priceLowHigh: "Price (Low to High)",
    },
    statuses: {
      new: "New",
      processing: "Processing",
      completed: "Ready",
      cancelled: "Cancelled",
      "out for delivery": "Out for Delivery",
      delivered: "Delivered",
      "delivery failed": "Delivery Failed",
      "awaiting payment": "Awaiting Payment",
    },
    sources: {
      viber: "Viber",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      manual: "Manual",
      facebookMessenger: "Facebook Messenger",
      instagram: "Instagram",
    },
    detail: {
      title: "Order Details",
      orderNumber: "Order Number",
      status: "Status",
      category: "Category",
      assignedTo: "Assigned To",
      customerInfo: "Customer Information",
      socialName: "Social Name",
      realName: "Real Name",
      phone: "Phone",
      address: "Address",
      orderDetails: "Order Details",
      parsedItems: "Parsed Items",
      rawInput: "Raw Input",
      price: "Price",
      orderComments: "Order Comments",
      comments: "Comments",
      source: "Source",
      createdAt: "Created At",
      viewFormatted: "View Formatted",
      viewRaw: "View Raw JSON",
      confirmDelete: "Are you sure?",
      deleteWarning: "This action cannot be undone. This will permanently delete the order.",
      deleting: "Deleting...",
      saving: "Saving...",
      saveChanges: "Save Changes",
      unsavedChanges: "Unsaved Changes",
      unsavedChangesWarning:
        "You have unsaved changes that will be lost. Are you sure you want to close without saving?",
      continueEditing: "Continue Editing",
      discardChanges: "Discard Changes",
      sectionMetadata: "Order Metadata",
      sectionCustomer: "Customer Information",
      sectionOrderDetails: "Order Details",
      sectionStatus: "Status & Management",
      deliveryHistory: "Delivery History",
      useEditor: "Use Editor",
      rawJSON: "Raw JSON",
      change: "change",
      changes: "changes",
    },
    add: {
      title: "Add New Order",
      smartInput: "Smart Input",
      smartInputDesc: "Paste message with emoji structure for automatic parsing",
      manualEntry: "Manual Entry",
      manualEntryDesc: "Fill out the form manually",
      toggleHelp: "Toggle help",
    },
    messages: {
      exportSuccess: "Orders exported to Excel successfully",
      exportWordSuccess: "Word document exported successfully",
      exportSelectedSuccess: "Selected orders exported to Excel successfully",
      exportSelectedWordSuccess: "Selected orders exported to Word successfully",
      noOrdersToExport: "No orders available to export. Add some orders first.",
      exportWordError: "Word document couldn't be exported. Let's try again.",
      updateSuccess: "Order saved successfully",
      updateError: "Order update didn't go through",
      deleteSuccess: "Order removed",
      deleteError: "Couldn't remove this order",
      validationError: "Something needs fixing",
      createSuccess: "Order created successfully",
      createError: "Order wasn't created. Let's try again.",
      fetchError: "Couldn't load orders",
      bulkEditSuccess: "Orders updated successfully",
      bulkEditError: "Orders couldn't be updated",
      archiveSuccess: "{{count}} order(s) archived",
      archiveError: "Archiving didn't complete",
      archiveUndo: "Archive undone - orders restored",
      restoreSuccess: "{{count}} order(s) restored",
      restoreError: "Restore didn't complete",
      restoreUndo: "Restore undone - orders archived",
      deletePermSuccess: "Orders permanently deleted",
      deletePermError: "Couldn't permanently delete orders",
      duplicateCheckError: "Couldn't check for duplicate order number",
      databaseUpdateError: "Order couldn't be saved to database",
      databaseDeleteError: "Order couldn't be removed from database",
      newOrderReceived: "New order received!",
    },
    notAnOrder: {
      title: "This doesn't look like a new order",
      description: "The text appears to be a different type of conversation",
      detected: "Detected",
      extractedInfo: "Extracted Information",
      orderRef: "Order reference",
      suggestion: "Tip",
      copyPhone: "Copy Phone",
      phoneCopied: "Phone Copied",
      phoneCopiedDesc: "You can use this phone number to search for existing orders",
      tryDifferent: "Try Different Text",
      messages: {
        order_modification: "This appears to be a request to modify an existing order.",
        order_inquiry: "This appears to be a question about order status.",
        complaint: "This appears to be a complaint about an existing order.",
        general_inquiry: "This appears to be a general question, not a new order.",
        unclear: "Unable to determine if this is a new order or something else.",
        default: "This does not appear to be a new order.",
      },
      suggestions: {
        order_modification: "Search for the customer's existing order to make changes.",
        order_inquiry: "Search for the customer's order to check its status.",
        complaint: "Find the customer's order to address their concern.",
        general_inquiry: "This is a general question - no order to create.",
        unclear: "Review the message again or ask for clarification.",
        default: "Review the message to determine the appropriate action.",
        phoneHint: "Use phone number {{phone}} to search.",
      },
    },
    incomplete: {
      title: "Incomplete Order Data",
      description: "Some required fields are missing from the extracted order",
    },
    conversationType: {
      newOrder: "New Order",
      modification: "Order Modification",
      inquiry: "Order Inquiry",
      complaint: "Complaint",
      general: "General Question",
      unclear: "Unclear",
    },
    placeholders: {
      orderNumber: "e.g., 133",
      customerName: "John Doe",
      customerPhone: "+1234567890",
      csrName: "e.g., თიკო",
      address: "123 Main Street, Tbilisi",
      orderMessage: "საწმენდი სპრეი 2 ცალი, სახელსახოცი 3 ცალი...",
      selectCategory: "Select category (required)",
      selectCategoryOptional: "Select category",
      totalPrice: "0.00 ₾",
      comments: "Any special notes or instructions...",
      noAddress: "No address provided",
      managerName: "Manager name",
      socialHandle: "Social media handle or display name",
      fullName: "Full name with surname",
      deliveryNotes: "Delivery notes, timing, special instructions...",
      pasteMessage: "Paste Viber/WhatsApp message here...",
      pasteMinimal: "Paste message here…",
      pasteExample: "Example:\nანა გელაშვილი\n599123456\nვაჟა-ფშაველას 10\nსაწმენდი სპრეი - 2 ცალი - 15 ლარი",
      parsedItems: "e.g., საწმენდი სპრეი x2, სახელსახოცი x3, ჭურჭლის სპრეი x1",
      selectDeliveryDate: "Select delivery date",
    },
    labels: {
      orderId: "Order ID",
      lastUpdated: "Last Updated",
      postedBy: "Posted By (CSR)",
      extractedData: "Extracted Data",
      startOver: "Start Over",
      socialName: "Social Name",
      realName: "Real Name *",
      phoneIcon: "Phone",
      deliveryAddress: "Delivery Address",
      deliveryAddressSimple: "Delivery Address",
      products: "Products",
      totalPriceIcon: "Total Price (₾)",
      commentsIcon: "Comments & Timing",
      pasteOrderMessage: "Paste Order Message",
      orderNumber: "Order Number",
      customerName: "Customer Name *",
      customerPhone: "Customer Phone",
      csrName: "Posted By (CSR Name)",
      source: "Source",
      category: "Category *",
      totalPrice: "Total Price",
      commentsSpecial: "Comments / Special Instructions",
      orderMessage: "Order Message",
      orderMetadata: "Order Metadata",
      customerInformation: "Customer Information",
      pricingDetails: "Pricing & Details",
      context: "Context",
      contextPlaceholder: "Select context (optional)",
      contextHint: "Used for internal grouping. Does not affect delivery flow.",
      requestedDeliveryDate: "Requested Delivery Date",
      noDeliveryDate: "No specific date (immediate)",
      moreDetails: "+ More order details",
      deliveryTime: "Delivery Time",
    },
    buttons: {
      processingAI: "Processing with AI...",
      processAI: "Process with AI",
      saveOrder: "Save Order",
      createOrder: "Create Order",
      saving: "Saving...",
      addOrder: "Add Order",
    },
    descriptions: {
      viewEditOrder: "View and edit order details, status, and customer information.",
    },
    errors: {
      categoryRequired: "Category is required",
      customerNameRequired: "Customer name is required",
      pasteTextRequired: "Please paste some text to process",
      extractionFailed: "Could not extract order data. Please use manual entry.",
      failedToExtract: "Failed to extract order data",
    },
    success: {
      orderCreated: "Great! New order added",
      orderExtracted: "Order data extracted successfully. Review and edit if needed.",
      extractionSuccess: "Success!",
    },
    duplicate: {
      title: "Duplicate Order Number",
      description: "Order #{{orderNumber}} already exists. Please use a different order number.",
    },
    unsavedChanges: {
      title: "Unsaved Changes",
      description: "You have {{count}} unsaved change(s). Are you sure you want to discard them?",
      continueEditing: "Continue Editing",
      discardChanges: "Discard Changes",
    },
    smart: {
      helperText: "Paste from WhatsApp/Viber/Messenger. One order is enough.",
    },
    example: {
      hint: "Paste messages from WhatsApp, Viber, or any messenger. Include customer name, phone, address, and products.",
    },
  },
  dashboard: {
    title: "Dashboard & Analytics",
    viewOrders: "View Orders",
    dateRange: "Date Range",
    quickPresets: "Quick Presets",
    from: "From",
    to: "To",
    today: "Today",
    yesterday: "Yesterday",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    monthToDate: "Month to Date",
    yearToDate: "Year to Date",
    clearFilter: "Clear",
    filter: {
      allOrders: "All Orders",
      deliveredOnly: "Delivered Only",
    },
    metrics: {
      totalOrders: "Total Orders",
      totalRevenue: "Total Revenue",
      avgOrderValue: "Avg Order Value",
      completionRate: "Completion Rate",
      unitsSold: "Units Sold",
      deliverySuccessRate: "Delivery Success",
      trendSuffix: "from last period",
    },
    charts: {
      ordersOverTime: "Orders Over Time",
      revenueOverTime: "Revenue Over Time",
      ordersByStatus: "Orders by Status",
      ordersBySource: "Orders by Source",
      revenueBySource: "Revenue by Source",
      ordersByCategory: "Orders by Category",
      topCustomers: "Top Customers",
      recentOrders: "Recent Orders",
      dailyOrderTrend: "Daily order count trend",
      dailyRevenue: "Daily revenue in ₾",
      statusDistribution: "Distribution of order statuses",
      sourceDistribution: "Distribution by order source",
      revenueDistribution: "Distribution by revenue source",
      topCategoriesDescription: "Top 5 order categories",
      customersSpending: "Customers by total spending",
      latestOrders: "Latest orders from your system",
      ordersLabel: "Orders",
      unitsLabel: "Units",
      dailyOrderAndUnitTrend: "Daily order count and units sold",
      monthlyOrderAndUnitTrend: "Monthly order count and units sold",
      monthlyOrderTrend: "Monthly order count trend",
      monthlyRevenue: "Monthly revenue in ₾",
      hourlyRevenue: "Hourly revenue in ₾",
      todayRevenue: "Today's Revenue",
      allOrdersFrom: "All orders",
      allRevenueFrom: "All revenue from",
      mostlyOrdersFrom: "Mostly",
      mostlyRevenueFrom: "Mostly from",
      granularityDaily: "Daily",
      granularityMonthly: "Monthly",
      revenueLabel: "Revenue (₾)",
    },
    emptyStates: {
      noData: "No data available",
      noOrders: "No orders in selected date range",
      noRevenue: "No revenue data",
      noStatus: "No status data",
      noSource: "No source data",
      noCategory: "No category data",
      noCustomers: "No customer data available",
      noRecentOrders: "No recent orders",
      customersWillAppear: "Customer analytics will appear here",
      ordersWillAppear: "Orders will appear here once created",
    },
    chartError: {
      title: "{{chartName}} Error",
      retry: "Retry",
      description: "Unable to display {{chartName}}. This might be due to invalid data or a temporary issue.",
    },
    table: {
      customer: "Customer",
      orders: "Orders",
      revenue: "Revenue",
      avgOrderValue: "Avg Value",
      lastOrder: "Last Order",
      orderNumber: "Order #",
      status: "Status",
      amount: "Amount",
      customerName: "Customer Name",
      phone: "Phone",
      totalSpent: "Total Spent (₾)",
      viewAll: "View All",
    },
    export: {
      csv: "Export CSV",
      rawData: "Export Data",
      labels: {
        date: "Date",
        orders: "Orders",
        revenue: "Revenue (₾)",
        status: "Status",
        count: "Count",
        percentage: "Percentage",
        category: "Category",
        source: "Source",
        orderNumber: "Order #",
        customer: "Customer",
        phone: "Phone",
        address: "Address",
        price: "Price (₾)",
        comments: "Comments",
        deliveredAt: "Delivered At",
        quantity: "Quantity",
        products: "Products",
      },
    },
    periodSummary: {
      title: "Insights",
      loading: "Analyzing your data...",
      error: "Couldn't generate summary",
      retry: "Refresh summary",
      generatedBy: "AI Summary",
    },
  },
  bulk: {
    title: "Bulk Order Upload",
    uploadTab: "Excel Upload",
    smartPasteTab: "Smart Paste",
    excelUploadDesc: "Upload an Excel file with Viber/WhatsApp chat export",
    smartPasteDesc: "Paste chat messages directly for processing",
    dragDrop: "Drag & drop an Excel file here, or click to select",
    fileTypes: "Supports .xlsx and .xls files",
    uploading: "Uploading...",
    processing: "Processing with AI...",
    analyzing: "Analyzing",
    parsingOrders: "Parsing orders...",
    longOperationHint: "Large batches may take up to ~1 minute. Please wait...",
    pasteInstructions: "Paste the exported chat messages below",
    pasteTextarea: "Paste chat text here...",
    parseOrders: "Parse Orders",
    importSelected: "Import Selected ({{count}})",
    import: "Import",
    importing: "Importing...",
    backToUpload: "Back to Upload",
    newUpload: "New Upload",
    summary: {
      title: "Import Summary",
      success: "{{count}} order successfully added!",
      successPlural: "{{count}} orders successfully added!",
      failed: "{{count}} order failed to import",
      failedPlural: "{{count}} orders failed to import",
      duplicates: "{{count}} duplicate detected",
      duplicatesPlural: "{{count}} duplicates detected",
      imported: "Successfully Imported",
      failedToImport: "Failed to Import",
      duplicatesFound: "Duplicates Found",
      processedIn: "Processed in",
      seconds: "seconds",
      estimatedManualEntry: "Estimated manual entry:",
      minutes: "minutes",
      timeSaved: "You saved approximately",
      estimatedTimeSaved: "Estimated time saved:",
      hours: "hours",
      timeCalculationNote: "(Based on avg 3 min per manual order entry)",
      errorDetails: "Error Details:",
    },
    review: {
      title: "Review and Select Orders",
      select: "Select",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      validOrders: "Valid Orders: {{count}}",
      invalidOrders: "Invalid: {{count}}",
      selectedCount: "Selected: {{count}}",
      filterAll: "All Orders",
      filterValid: "Valid Only",
      filterErrors: "Errors Only",
      filterDuplicates: "Duplicates Only",
      filterRejected: "Rejected",
    },
    statuses: {
      rejected: "Rejected",
      duplicate: "Duplicate",
      error: "Error",
      warning: "Warning",
      edited: "Edited",
      valid: "Valid",
      editing: "Editing",
      ready: "Ready",
    },
    actions: {
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      reject: "Reject",
      compare: "Compare",
      restore: "Restore",
      compareWithExisting: "Compare with existing order",
      remove: "Remove",
    },
    duplicate: {
      title: "Duplicate Order Comparison",
      newOrder: "New Order",
      existing: "Existing",
      fromUpload: "From current upload",
      fromDatabase: "From database",
      earlierInBatch: "Earlier in batch",
      orderNumber: "Order #:",
      customer: "Customer:",
      phone: "Phone:",
      address: "Address:",
      total: "Total:",
      products: "Products:",
      created: "Created:",
      checkRow: "Check row:",
      detectionWarning: "Duplicate Detection",
      close: "Close",
    },
    rejected: {
      title: "Rejected Orders",
      count: "{{count}} order rejected",
      countPlural: "{{count}} orders rejected",
      restoreAll: "Restore All",
      empty: "No rejected orders",
    },
    tips: {
      title: "Tips",
      editReject: "Click row to edit, use reject button to exclude",
      editInline: "Edit fields directly. Changes save automatically.",
      excelFormat: "Make sure the Excel contains chat messages in standard format",
      excelStructure: "Each order should start with [ date/time ] structure",
      excelExtract: "AI will automatically extract customer details, products, and prices",
      pasteDirect: "Paste messages directly from Viber/WhatsApp",
      pasteFormats: "AI understands various formats and emoji structures",
      pasteMultiple: "You can paste multiple orders at once",
    },
    maxSize: "💾 Max size: 10 MB",
    errors: {
      uploadFailed: "File couldn't be uploaded",
      processingFailed: "Orders couldn't be processed",
      noFile: "Please select a file",
      noPaste: "Please paste text to process",
      importFailed: "Orders couldn't be imported",
      invalidFile: "Invalid file",
      invalidFileDesc: "Please upload a valid file (.xlsx, .xls, or .csv)",
      noOrders: "No orders found",
      extractionFailed: "Could not extract orders from the file",
      timeout: "Processing Timeout",
      timeoutDesc: "The request took too long. Try with a smaller file or fewer orders.",
      rateLimit: "Rate Limit Reached",
      rateLimitDesc: "Too many requests. Please wait a moment and try again.",
      creditsRequired: "Credits Required",
      creditsRequiredDesc: "AI credits are required. Please add credits to continue.",
      timeoutWithCount: "Processing timed out. You have ~{{count}} orders. Try with {{max}} or fewer orders at a time.",
      duplicateInternal: "Duplicate order #{{orderNumber}} in this batch (first appears at row {{row}})",
      duplicateDatabase: "Order #{{orderNumber}} already exists in your database",
    },
    processingBatches: "Processing batches...",
    largeFileWarning: "Large file detected. Processing may take up to 60 seconds.",
    reviewOrders: "Review Orders",
    chooseFile: "Choose file",
    constraintsExcel: ".xlsx, .xls, .csv • Max 10MB",
    dropFile: "Drop file here or choose",
    dropHere: "Drop file here",
    constraintsPaste: "Paste from Viber/WhatsApp • Multiple orders supported",
    characters: "characters",
    mayTakeLong: "may take 1+ min",
    reviewBeforeImport: "You'll review all orders before anything is created",
  },
  categories: {
    cleaningSupplies: "Cleaning Supplies",
    kitchenItems: "Kitchen Items",
    bathroomProducts: "Bathroom Products",
    homeDecor: "Home Decor",
    storageOrganization: "Storage & Organization",
    textiles: "Textiles",
    smallAppliances: "Small Appliances",
    toolsHardware: "Tools & Hardware",
    other: "Other",
    // Extended categories
    householdGoods: "Household Goods",
    clothingFashion: "Clothing & Fashion",
    electronics: "Electronics",
    foodRestaurant: "Food & Restaurant",
    pharmacyMedical: "Pharmacy & Medical",
    retailGeneral: "Retail & General",
    // Database categories
    b2b: "B2B",
    clothing: "Clothing",
    electronicsAppliances: "Electronics & Appliances",
    food: "Food",
    sportingGoods: "Sporting Goods",
  },
  products: {
    title: "Products",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    addProductDesc: "Create a new product for external ordering",
    editProductDesc: "Update product details",
    productDetails: "Product Details",
    pricing: "Pricing",
    noProducts: "No products added yet. Click 'Add Product' to start.",
    noProductsFound: "No products found",
    addFirstProduct: "Add your first product",
    productName: "Product name",
    productNamePlaceholder: "e.g., Bagel",
    productCode: "SKU / Product code",
    productCodePlaceholder: "e.g., PROD-001",
    category: "Category",
    selectCategory: "Select category",
    unit: "Unit",
    basePrice: "Price",
    variationNote: "Variation prices are added to this base price",
    unitPiece: "Piece",
    unitKg: "Kg",
    unitLiter: "Liter",
    unitMeter: "Meter",
    unitSet: "Set",
    quantity: "Qty",
    price: "Price",
    remove: "Remove",
    uncategorized: "Uncategorized",
    categoryLink: "Category Link",
    disableCategory: "Disable Category",
    disableCategoryDescription: "This category has active products. Disabling will prevent customers from ordering via this link.",
    confirmDelete: "Are you sure you want to delete this product?",
    confirmDeleteTitle: "Delete Product",
    linkCopied: "Link copied",
    copyFailed: "Copy failed",
    toggleIntake: "Toggle external intake",
    productImage: "Product image",
    uploadImage: "Upload image",
    removeImage: "Remove image",
    imageUploadError: "Image couldn't be uploaded",
    imageSizeError: "Image must be less than 2MB",
    imageFormatError: "Only JPEG, PNG, and WebP formats are allowed",
    columns: {
      product: "Product",
      price: "Price",
      intake: "Intake",
      ordersToday: "Today",
    },
    copyLink: "Copy link",
    openLink: "Open link",
    productsCount: "products",
    activeCount: "active",
    activeCategoryCount: "active",
    toasts: {
      added: "Product added",
      updated: "Product updated",
      deleted: "Product deleted",
      stockUpdated: "Stock updated",
      error: "Error: {{message}}",
    },
  },
  units: {
    piece: "Piece",
    kg: "Kg",
    liter: "Liter",
    meter: "Meter",
    set: "Set",
  },
  notFound: {
    title: "404",
    message: "Oops! Page not found",
    returnHome: "Return to Home",
  },
  register: {
    title: "Start Your Free Trial",
    subtitle: "Get 14 days of full access - no credit card required",
    modal: {
      title: "Start Together",
      subtitle: "Join OrderFlow and transform your order management",
      switchToLogin: "Already have an account?",
      signIn: "Sign In",
    },
    personalInfo: "Personal Information",
    businessInfo: "Business Information",
    fullName: "Full Name",
    email: "Email Address",
    phone: "Phone Number",
    companyName: "Company Name",
    businessType: "Business Type",
    referralSource: "How did you hear about us?",
    message: "Tell us about your business",
    fullNamePlaceholder: "John Doe",
    emailPlaceholder: "john@company.com",
    phonePlaceholder: "+995 XXX XXX XXX",
    companyNamePlaceholder: "Your Company Ltd.",
    selectBusinessType: "Select business type",
    selectReferralSource: "Select source",
    messagePlaceholder: "Number of orders per day, specific needs, etc.",
    termsPrefix: "By submitting this form, you agree to our",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    requestAccess: "Request Access",
    submitting: "Submitting...",
    haveAccount: "Already have an account?",
    signIn: "Sign in",
    alreadyHaveAccount: "Already have an account?",
    trialInfo: "Start with a 14-day free trial. Full access to all features, no credit card required.",
    sections: {
      accountInfo: "Account Credentials",
      personalInfo: "Personal Information",
      businessInfo: "Business Information",
    },
    fields: {
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      password: "Password",
      confirmPassword: "Confirm Password",
      companyName: "Company Name",
      businessType: "Business Type",
      referralSource: "How did you hear about us?",
      message: "Tell us about your business",
    },
    placeholders: {
      fullName: "John Doe",
      email: "john@company.com",
      phone: "+995 XXX XXX XXX",
      password: "Min. 8 characters",
      confirmPassword: "Repeat your password",
      companyName: "Your Company Ltd.",
      selectType: "Select business type",
      selectSource: "Select source",
      message: "Number of orders per day, specific needs, etc.",
    },
    hints: {
      optional: "Optional",
      characters: "characters",
      passwordMin: "Minimum 8 characters",
    },
    terms: {
      bySubmitting: "By creating an account, you agree to our",
      termsOfService: "Terms of Service",
      and: "and",
      privacyPolicy: "Privacy Policy",
    },
    buttons: {
      submit: "Submit Application",
      submitting: "Submitting...",
      startTrial: "Start Free Trial",
      creating: "Creating account...",
    },
    errors: {
      invalidEmail: "Please enter a valid email address",
      requiredField: "This field is required",
      validationFailed: "Validation Failed",
      checkFields: "Please check the required fields",
      contactSupport: "Please contact our support team for assistance.",
      tryAgain: "Please try again later.",
      submissionFailed: "Registration Failed",
      emailExists: "An account with this email already exists. Please sign in instead.",
      passwordMismatch: "Passwords don't match",
      passwordTooShort: "Password must be at least 8 characters",
    },
    success: {
      title: "Success!",
      description: "Your application has been submitted successfully.",
      welcome: "Welcome to OrderFlow!",
      trialStarted: "Your 14-day free trial has started. Explore all features!",
      loginManually: "Account created! Please sign in to continue.",
    },
  },
  demo: {
    title: "Try It Now",
    inputLabel: "Paste your order message",
    placeholder: "Paste order text here or use the example...",
    processButton: "Process with AI",
    flowGuide: {
      paste: "Paste",
      process: "Process",
      results: "See Results",
    },
    processing: "Processing...",
    saveButton: "Save Order & Start Trial",
    tryAnother: "Try Another Order",
    rateLimit: "Demo limit reached. Register to continue!",
    rateLimitCta: "Register for Free",
    emptyInput: "Please paste an order message to process.",
    processingError: "Order couldn't be processed. Let's try again.",
    attemptsRemaining: "Demo attempts remaining",
    freeTriesRemaining: "free tries",
    sampleOrder: `January 12, 2025

Nika • 11:07 Hello 🤗 How much is a double bed? 2050 × 1500 × 1040 mm dimensions

Temo • 11:08 Hello Nika, 950 GEL

Nika • 11:09 Would you give it to me for 850 GEL? I'll pay today 🙏

Temo • 11:11 I can do 850 GEL if you pay cash.

Nika • 11:12 Thank you so much. Can you deliver?

Temo • 11:13 Yes, please give me the address.

Nika • 11:14 Vazisubani, Kakheti Highway N45.

Temo • 11:16 Got it. Which day do you prefer?

Nika • 11:17 Tomorrow, somewhere between 14:00–17:00.

Temo • 11:18 Okay, I'll schedule it like that.

Temo • 11:19 Nika, please leave your number, I'll give it to the courier.

Nika • 11:20 597 12 34 56

Temo • 11:21 Thank you. They'll call you before arriving tomorrow.`,
    results: {
      title: "Data Extracted",
      timeSaved: "Saved ~2 minutes",
      customer: "Customer",
      phone: "Phone",
      address: "Address",
      products: "Product",
      price: "Price",
    },
  },
  thankYou: {
    title: "Application Received!",
    subtitle: "Thank you for your interest! We've received your application and will review it within 24-48 hours.",
    whatHappensNext: "What Happens Next?",
    steps: {
      verification: {
        title: "We'll verify your information",
        description: "Our team will review your business details and ensure everything is in order.",
      },
      review: {
        title: "Review within 24-48 hours",
        description: "You'll receive an email with our decision and next steps.",
      },
      password: {
        title: "Set your password",
        description: "Once approved, you'll receive an email with a secure link to set your password.",
      },
      access: {
        title: "Start using OrderFlow",
        description: "After setting your password, you can sign in and start managing your orders immediately.",
      },
    },
    note: {
      title: "Important",
      description: "Please check your email inbox (and spam folder) for updates on your application status.",
    },
    buttons: {
      backHome: "Back to Home",
      signIn: "Sign In",
    },
    support: {
      question: "Have questions?",
      contactUs: "Contact us",
    },
  },
  // Progressive Onboarding - Explore flow (email-only entry)
  explore: {
    title: "Start exploring OrderFlow",
    subtitle: "Enter your email to try the system.",
    noSetup: "No setup, no commitment.",
    continue: "Continue",
    passwordLater: "You'll set a password later.",
    alreadyHaveAccount: "Already have an account?",
    loginLink: "Log in",
    login: "Log in",
    trialInfo: "14 day trial · No card required · Cancel anytime",
    accountExists: "Account already exists",
    accountExistsDesc: "An account with this email already exists. Please log in instead.",
    success: "Account created",
    successSetPassword: "Please set a password to continue.",
    welcome: "Welcome!",
    welcomeDesc: "You're ready to explore OrderFlow.",
    error: "Something went wrong",
  },
  // Secure Account Banner & Modal
  secureAccount: {
    title: "Secure your account",
    description: "Set a password so you can easily log in again. Or use 'Forgot Password' next time to get a login link.",
    emailLabel: "Login link goes to",
    setPassword: "Set password",
    later: "Later",
    createTitle: "Create your password",
    createDescription: "This protects your account and lets you log in anytime.",
    password: "Password",
    confirmPassword: "Confirm password",
    save: "Save password",
    saving: "Saving...",
    success: "Password saved successfully",
    noPasswordYet: "This account doesn't have a password yet",
    setToLogin: "Set password to log in",
    setToLoginDesc: "You started exploring without a password. Set one now to log in.",
    passwordSetSuccess: "Password set successfully",
    passwordSetSuccessDesc: "You can now log in with your email and password.",
  },
  landing: {
    // Calm Utility Landing - Single Column Mobile-First Design
    hero: {
      headline: "All your orders in one place",
      subheadline: "No more Viber chaos. No more calling couriers 10 times a day.",
      cta: "See how it works",
      priceHint: "Free 14 days • Then 50₾/month",
    },
    ctaSubtext: "14 day trial · No card required · Cancel anytime",
    signIn: "Sign In",
    nav: {
      menu: "Menu",
      about: "About",
      howItWorks: "How It Works",
      pricing: "Pricing",
    },
    // Local Trust Bar - Simple line
    localTrust: {
      builtFor: "Built for SME",
      worksWithWorkflow: "Works with your existing workflow",
    },
    // Demo UI translations
    demo: {
      needsAttention: "Needs Attention",
      today: "Today",
      tableHeaders: {
        note: "Note",
        session: "Session",
        customer: "Customer",
        product: "Product",
        status: "Status",
        log: "Log",
      },
      statuses: {
        New: "New",
        Processing: "Processing",
        Ready: "Ready",
        "Out for Delivery": "In Transit",
        Delivered: "Delivered",
        "Delivery Failed": "Failed",
        Cancelled: "Cancelled",
      },
      // Courier Flow
      ordersSelected: "orders selected",
      generateLink: "Generate Link",
      linkReady: "Link Ready",
      orders: "Orders",
      expires: "Expires",
      endOfDay: "End of day",
      deliveryList: "Delivery List",
      liveSync: "Live Sync",
      updated: "Updated",
      startDelivery: "Start Delivery",
      delivered: "Delivered",
      // Shared Log
      managerView: "Manager View",
      courierView: "Courier View",
      history: "History",
      // Order Intake
      linkCreated: "Link Created",
      shareOn: "Share on Instagram/WhatsApp",
      familyBakery: "Family Bakery",
      orderForm: "Order Form",
      formLabels: {
        name: "Name *",
        phone: "Phone *",
        address: "Address *",
        quantity: "Quantity",
        note: "Note",
        optional: "Optional",
        pieces: "pieces",
      },
      submit: "Submit",
      // Planning Radar
      upcoming: "Upcoming",
      tomorrow: "Tomorrow",
      // Sample data
      sampleNames: {
        george: "George M.",
        anna: "Anna G.",
        nino: "Nino B.",
        david: "David K.",
        mariam: "Mariam T.",
        levan: "Levan G.",
        tekla: "Tekla J.",
      },
      sampleAddresses: {
        vake: "Vake, Abashidze 12",
        isani: "Isani, Navtlugi 23",
        saburtalo: "Saburtalo, Peking 45",
        didube: "Didube, Tsereteli 78",
        gldani: "Gldani, Khizanishvili 5",
        nadzaladevi: "Nadzaladevi, Guramishvili 12",
      },
      sampleProducts: {
        shirt: "Shirt",
        jacket: "Jacket",
        bag: "Bag",
        shoes: "Shoes",
        watch: "Watch",
        dress: "Dress",
        belt: "Belt",
        coat: "Coat",
      },
      sampleAlerts: {
        delayedDelivery: "Delayed delivery...",
        clientNotResponding: "Client not responding...",
        orderWaiting: "Order waiting",
      },
      sampleLogs: {
        orderReceived: "Order received",
        readyForDelivery: "Ready for delivery",
        handedToCourier: "Handed to courier",
        confirmed: "Confirmed",
        inTransit: "In transit",
        deliveredCheck: "Delivered ✓",
        paidCash: "Paid cash",
        trafficDelay: "Traffic, 10 min away",
        warehousePreparing: "Warehouse preparing, pick up tomorrow",
        secondFloorApt8: "OK, 2nd floor, apt 8",
        deliveredPaidCash: "Delivered, paid cash",
        orderCreated: "Order created",
        readyIn2Hours: "Ready in 2h, warehouse",
        pickedUpInVake: "Picked up, in Vake now",
        leftWithNeighbor: "Left with neighbor",
      },
      courier1: "Courier 1",
      courier2: "Courier 2",
      contextPriority: "Priority",
    },
    // Pain Recognition Section - Blunt problems
    pain: {
      headline: "Sound familiar?",
      messages: "Too many messages scattered everywhere",
      calling: "Calling couriers all day long",
      lostOrders: "Lost or unclear orders",
      noStatus: "No clear delivery status",
    },
    // Linear Flow Section - Simple pipeline with 5 steps
    flow: {
      headline: "How it works",
      orderIn: "Order comes in",
      orderInMethods: "Forms · Messages · Manual · Bulk",
      organizes: "OrderFlow organizes",
      organizesMethods: "Today · Tomorrow · This Week · Custom",
      shareLink: "Share link with courier",
      delivers: "Courier delivers",
      deliversMethods: "Courier · Partner · Post · Pickup",
      logged: "Everything is logged",
      loggedMethods: "Timeline · Status · Notes · History",
      bonus: {
        liveSync: "Live sync",
        sharedLog: "Shared log",
        liveStatuses: "Live statuses",
      },
    },
    // Product Preview Section - Now demo components
    preview: {
      label: "Product",
      headline: "This is what you'll see",
      subheadline: "Real interface, for real business",
      boardHeadline: "Your daily management board",
      boardDescription: "See at a glance what needs attention and what's in progress right now.",
      courierHeadline: "Manager to Courier",
      courierDescription: "One link gives your courier the route. No Viber, no confusion.",
      planningHeadline: "Upcoming orders — while you manage today",
      planningDescription: "A calm view of tomorrow and beyond",
      intakeHeadline: "External orders — organized",
      intakeDescription: "Share a link. Orders come in neatly.",
      orderList: "Order list",
      statusChange: "Status changes",
      deliveryLog: "Delivery log",
      liveSync: "Live sync",
      dashboard: "Dashboard",
      courierView: "Courier view",
      courierFlow: "Manager → Courier",
      planning: "Upcoming orders",
    },
    // Shared Log Section - Key Differentiator
    sharedLog: {
      label: "Key Differentiator",
      headline: "One shared log. No more blame games.",
      description: "Manager sees the full picture — courier sees only what they need. No more blame, no more confusion.",
      point1: "Manager & courier share one factual timeline",
      point2: "No more message chaos",
      replacesViber: "This replaces Viber for delivery coordination. It doesn't compete with it.",
      mockup: {
        manager: "Manager",
        managerAction: "Order dispatched to courier",
        courier: "Courier",
        courierAction: "Arrived at location",
        system: "System",
        systemAction: "✓ Delivered",
      },
    },
    // Who It's For Section
    whoItsFor: {
      headline: "Is this for you?",
      goodForLabel: "Good for",
      notForLabel: "Not for",
      good1: "Small shops and online sellers",
      good2: "Food delivery businesses",
      good3: "Repair and service centers",
      good4: "Anyone managing 5-100 orders/day",
      not1: "Large enterprises with complex ERP needs",
      not2: "Restaurants needing POS integration",
    },
    // Final CTA - Low commitment
    finalCta: {
      headline: "See how it works",
      subheadline: "Nothing changes until you're ready.",
      button: "See how it works",
      disclaimer: "14 day trial · No card required · Cancel anytime",
    },
    // Pricing Section - 3-tier structure
    pricing: {
      label: "Pricing",
      headline: "Pricing that grows with your business",
      subheadline: "No feature lockouts. No penalties for growth. Just clear guidance.",
      currency: "₾",
      period: "/ month",
      
      // Tier: Starter
      starter: {
        name: "Starter",
        price: "39",
        tagline: "For small, low-volume operations",
        description: "Full order management when OrderFlow is helpful, but not yet business-critical.",
        capacity: "Designed for ~0-150 orders/month",
      },
      // Tier: Growth
      growth: {
        name: "Growth",
        price: "79",
        tagline: "For businesses running daily operations on OrderFlow",
        description: "Same features, higher operational comfort when one link is no longer enough.",
        capacity: "Designed for ~150-800 orders/month",
        badge: "Recommended",
      },
      // Tier: Unlimited
      unlimited: {
        name: "Pro",
        price: "129",
        tagline: "For high-volume, business-critical usage",
        description: "Built for scale, velocity, and zero friction.",
        capacity: "Designed for 800+ orders/month",
      },
      
      // Shared feature labels
      features: {
        orderManagement: "Full order management & tracking",
        customerTracking: "Customer & payment status tracking",
        deliveryFlow: "Delivery flow & external intake included",
        deliveryLink: "delivery link",
        deliveryLinks: "delivery links",
        intakeForm: "external order intake form",
        intakeForms: "external order intake forms",
        logsHistory: "Logs & order history",
        everything: "Everything in Starter",
        unlimitedLinks: "Unlimited delivery links",
        unlimitedForms: "Unlimited external intake forms",
        noCeiling: "No recommended order ceiling",
      },
      
      // Quantities
      quantity: {
        one: "1",
        upToFive: "Up to 5",
        unlimited: "Unlimited",
      },
      
      // Trust builder section
      trust: {
        headline: "Important",
        point1: "We never block features if you grow faster than your plan",
        point2: "We inform you, not punish you",
        point3: "Plan changes apply next billing cycle only",
      },
      
      // Emotional tagline
      tagline: "OrderFlow doesn't stop your business when you succeed.",
      
      // FAQ section
      faq: {
        label: "Pricing FAQ",
        items: {
          usage: {
            q: "How do you measure order volume?",
            a: "We look at your total orders per month. The tiers are guidance, not hard limits.",
          },
          exceed: {
            q: "What happens if I exceed my plan's recommended range?",
            a: "Nothing breaks. We'll inform you and suggest a better plan for your next billing cycle.",
          },
          change: {
            q: "When do plan changes take effect?",
            a: "Plan changes apply from the next billing cycle.",
          },
          links: {
            q: "What's the difference between delivery links and intake forms?",
            a: "Delivery links are for courier delivery status and control. Intake forms are for customers to place orders via an external link.",
          },
          starterLimits: {
            q: "Do all plans include delivery and external intake features?",
            a: "Yes. Starter includes 1 delivery link and 1 intake form. Higher tiers include multiple or unlimited.",
          },
          cancel: {
            q: "Can I cancel anytime?",
            a: "Yes. You keep access until the end of your current billing period.",
          },
        },
      },
    },
    // About Us (comprehensive company profile)
    aboutUs: {
      // Section 1: What OrderFlow Does
      whatWeDoLabel: "What OrderFlow Does",
      whatWeDoText: "OrderFlow is a web application for small and medium businesses in Georgia that unifies and simplifies order intake, processing, delivery organization, and communication in one system.",
      // Section 2: Who It's For
      whoItsForLabel: "Who It's Built For",
      whoItsForText: "The platform is designed for online sellers, small shops, warehouse-based businesses, and small-to-medium distributors who receive orders from social networks and messengers, or want to improve their order intake process using OrderFlow's innovative order intake link (form).",
      // Section 3: Product Stage
      stageLabel: "Product Stage",
      stageText: "The product is in active use, in the functional testing (MVP) phase, and is constantly evolving based on real customer feedback.",
      // Section 4: Team
      teamLabel: "Team",
      teamFounder: "OrderFlow was founded by Jaba Tsenteradze — a professional with many years of experience in technology and business analytics, who has worked in both corporate and SME environments.",
      teamMembers: "The OrderFlow team also includes an experienced CFO and a marketing and customer relations specialist.",
      // Section 5: Closing Statement
      closingText: "The project is built on real operational experience and aims to simplify daily processes for small businesses.",
    },
    // Footer contact info
    footer: {
      phone: "Phone",
      email: "Email",
      followUs: "Follow Us",
    },
    // Footer
    company: {
      name: "OrderFlow",
      founded: "Founded: 2024",
      location: "Tbilisi, Georgia",
      mission: "Helping Georgian SMEs reclaim their time through intelligent order management",
      contact: "Contact: info@orderflow.ge",
    },
    madeInTbilisi: "Made in Georgia with love",
    georgianSupport: "Made in Georgia",
  },
  onboarding: {
    welcome: {
      title: "Welcome to OrderFlow! 🎉",
      subtitle: "Let's take a quick tour to help you get started",
      startTour: "Start Tour",
      skip: "Skip for now",
      timeEstimate: "Takes about 2 minutes",
    },
    steps: {
      smartVsManual: {
        title: "Two Ways to Add Orders",
        subtitle: "Choose the method that works best for you",
        whyMatters: "💡 Save 10+ minutes per day with the right choice",
        smartTitle: "Smart Input (AI)",
        smartDesc:
          "Simply paste Facebook Messenger, Viber or WhatsApp messages and AI extracts everything automatically",
        smartBadge: "⚡ Fastest",
        smartFeature1: "Paste messages directly",
        smartFeature2: "AI extracts all details",
        smartSpeed: "5-10 seconds per order",
        manualTitle: "Manual Entry",
        manualDesc: "Fill out form field by field for full control over every detail",
        manualBadge: "🎯 Precise",
        manualFeature1: "Complete form control",
        manualFeature2: "Perfect for phone orders",
        manualSpeed: "1-2 minutes per order",
      },
      workflow: {
        title: "Your Daily Workflow",
        subtitle: "Three sections keep you focused and organized",
        whyMatters: "Never miss an overdue order again",
        needsAttention: "Needs Attention",
        needsAttentionDesc: "Orders from previous days that need action",
        today: "Today",
        todayDesc: "Today's orders progressing through stages",
        todayStages: "New → Ready → Out for Delivery → Delivered",
        history: "History",
        historyDesc: "Completed orders from past days",
      },
      deliveryManagement: {
        title: "Delivery Management",
        subtitle: "Organize deliveries and share with couriers",
        whyMatters: "Track every order from warehouse to doorstep",
        sessionsTitle: "Dispatch Sessions",
        sharingTitle: "Courier Sharing",
        feature1: "Group 'Ready' orders into delivery batches",
        feature2: "Real-time progress tracking per session",
        feature3: "One-click link sharing with couriers",
        feature4: "Courier sees only what they need",
      },
      sessions: {
        title: "Dispatch Sessions",
        subtitle: "Organize your delivery runs efficiently",
        feature1: "Group 'Ready' orders into delivery batches",
        feature2: "One-click link sharing with your courier",
        feature3: "Real-time progress tracking per session",
        feature4: "Orders lock automatically when assigned",
      },
      upcomingDeliveries: {
        title: "Upcoming Deliveries",
        subtitle: "Never miss a scheduled delivery",
        feature1: "See all future orders with due dates",
        feature2: "Tomorrow's orders auto-surface to 'Needs Attention'",
        feature3: "Visual status: overdue, due today, due tomorrow",
        feature4: "Search and expand for quick access",
      },
      deliverySharing: {
        title: "Share with Couriers",
        subtitle: "Generate delivery links for your team",
        feature1: "Click 🔗 Share to create delivery link",
        feature2: "Choose which 'Ready' orders to include",
        feature3: "Courier sees only delivery info",
        feature4: "Track delivery progress in real-time",
      },
      exportAnalytics: {
        title: "Export & Analytics",
        subtitle: "Stickers and business statistics",
        stickersTitle: "Print Stickers",
        stickersDesc: "Customizable delivery stickers with emoji guides for couriers",
        emojiExamples: "address • phone • price • customer",
        dashboardTitle: "Dashboard",
        dashboardDesc: "Revenue trends, order analytics, and top customers",
      },
      getStarted: {
        title: "Ready to Get Started?",
        subtitle: "Choose how you'd like to create your first order",
        manual: "Create My First Order",
        smart: "Try Smart Input (AI)",
        bulk: "Upload Excel File",
        exportHint: "Print stickers anytime",
        dashboardHint: "See stats in Dashboard",
      },
    },
    checklist: {
      title: "Getting Started",
      createOrder: "Create your first order",
      createOrderHint: "Use Smart Input or Manual Entry on the Orders page",
      markReady: "Mark an order as Ready",
      markReadyHint: "Change any order's status to 'Ready for Delivery'",
      viewArchive: "View the Archive",
      viewArchiveHint: "See where completed orders are stored",
      viewDashboard: "Check your Analytics",
      viewDashboardHint: "Visit Dashboard to see your business stats",
      complete: "You're all set!",
      completeMessage: "You've mastered the basics of OrderFlow",
    },
    emptyState: {
      headline: "No Orders Yet - Let's Create Your First One!",
      description: "Choose how you'd like to add orders to your system",
      helpText: "Need help? Hover over the cards to learn more about each option",
    demoPrompt: "Want to see how it works first?",
    demoButton: "Create Demo Order",
    demoSuccess: "Demo order created! See how it appears in your list.",
    deleteDemoOrders: "Delete Demo",
    demoDeleteSuccess: "Demo orders deleted successfully",
      cards: {
        manual: {
          title: "Manual Entry",
          description: "Fill out a simple form for full control over every field",
          badge: "Traditional",
        },
        smart: {
          title: "Smart Input (AI)",
          description: "Paste Viber/WhatsApp messages - AI does the work",
          badge: "⚡ Recommended",
        },
        excel: {
          title: "Excel Upload",
          description: "Upload exported chat file for bulk import",
          badge: "Bulk",
        },
        paste: {
          title: "Smart Paste",
          description: "Copy-paste multiple orders at once",
          badge: "Fast",
        },
        dashboard: {
          title: "View Dashboard",
          description: "Explore analytics and reports even before adding orders",
          badge: "",
        },
        sample: {
          title: "Download Sample",
          description: "See Excel format example",
          badge: "",
        },
      },
    },
    featureComparison: {
      title: "🤔 Which method should you use?",
      smartTitle: "Smart Input (AI)",
      smartDesc:
        "Paste Viber/WhatsApp messages directly and AI extracts everything automatically. Perfect for daily order processing.",
      smartBadge: "⚡ Recommended",
      smartSpeed: "5-10 seconds per order",
      manualTitle: "Manual Entry",
      manualDesc:
        "Fill out form field by field with full control over data. Perfect for phone orders and custom entries.",
      manualBadge: "🎯 Precise",
      manualSpeed: "1-2 minutes per order",
    },
    tips: {
      afterFirstManual:
        "💡 Tip: Did you know you can paste Viber messages directly using Smart Input? Try it next time to save time!",
      after10Manual:
        "⚡ Time-saver: You've created 10 orders manually. Consider using Bulk Upload to process multiple orders at once!",
      after50Orders: "🎉 You're getting the hang of it! Have you checked the Dashboard to see your analytics?",
      archiveEmpty: "Archive orders here to keep your main list clean. Archived orders can always be restored.",
    },
    dontShowAgain: "Don't show this again",
    markComplete: "Mark as complete",
  },
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdated: "Last Updated: 15.11.2025",
    backToHome: "Back to Home",
    sections: {
      introduction: {
        title: "1. Introduction",
        content:
          'OrderFlow ("we," "us," "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and protect your information when you use our order management platform.',
      },
      informationWeCollect: {
        title: "2. Information Collection and Categories",
        intro: "We collect only the types of data necessary for the proper operation of the service:",
        youProvide: {
          title: "Information You Provide:",
          items: [
            "Account Details: First name, last name, email address, phone number, company name",
            "Commercial Data: Order history, customer contact information (from received chats), product lists and prices",
            "Registration Information: Additional data entered during registration or verification process",
          ],
        },
        automaticallyCollected: {
          title: "Information Automatically Collected:",
          items: [
            "Usage Data: How you interact with OrderFlow",
            "Technical Data: IP address, browser type and version, operating system, device data",
            "Session Data: Information about how you use the platform (through cookies and logs)",
          ],
        },
      },
      howWeUse: {
        title: "3. Information Usage Purposes",
        intro: "We use your data for the following purposes:",
        items: [
          "Providing OrderFlow services and technical support",
          "Account management, user identification, and security",
          "Processing orders from text messages via artificial intelligence (AI)",
          "Generating business analytics and statistical reports",
          "Fraud prevention and cybersecurity assurance",
          "Fulfilling legal obligations",
        ],
      },
      legalBasis: {
        title: "4. Legal Bases for Processing",
        intro:
          "Data processing is carried out in accordance with GDPR and Georgian legislation, based on the following grounds:",
        items: [
          "Contract Performance: To provide services",
          "Legitimate Interest: For service security and improvement",
          "Consent: To receive marketing communications (which you can cancel at any time)",
          "Legal Obligation: To satisfy tax and legal requirements",
        ],
      },
      dataSharing: {
        title: "5. Data Sharing",
        intro: "We do not sell or transfer your data to unauthorized parties. We share data only with:",
        serviceProviders: {
          title: "Service Providers:",
          items: ["Supabase (database hosting)", "Google Cloud (AI processing)", "Email service providers"],
        },
        other: [
          "Legal Necessity: Based on law, court order, or government agency request",
          "Business Reorganization: In case of company merger or acquisition (with data confidentiality protection guarantee)",
        ],
      },
      dataSecurity: {
        title: "6. Data Storage and Security",
        intro: "We use industry-standard security measures:",
        items: [
          "Encryption: Data is encrypted both in transit (TLS 1.3) and at rest/storage (AES-256)",
          "Backups: We use secure cloud infrastructure with regular data backups",
          "Access Control: Only strictly defined, authorized personnel have access to data",
        ],
      },
      dataRetention: {
        title: "7. Data Retention Periods",
        items: [
          "Active Accounts: Data is retained as long as you use our service",
          "After Account Cancellation: Financial and transactional data is retained for 6 years (for tax obligations)",
          "Deletion: After the retention period expires, data is subject to complete and irreversible destruction",
        ],
      },
      yourRights: {
        title: "8. Your Rights",
        intro: "Under GDPR and Georgian law, you have the right to:",
        items: [
          "Access: Request a copy of your data",
          "Rectification: Correct inaccurate data",
          "Erasure: Delete your account and data",
          "Portability: Export your data",
          "Object: Opt-out of certain processing",
          "Restrict: Limit how we use your data",
        ],
        contact: "To exercise these rights, contact: info@orderflow.ge",
      },
      internationalTransfers: {
        title: "9. International Transfers",
        intro: "Your data may be processed in:",
        items: [
          "Georgia (primary operations)",
          "European Union (database hosting)",
          "United States (AI processing with appropriate safeguards)",
        ],
        compliance:
          "We ensure that any cross-border transfers meet the security standards of GDPR and Georgian legislation.",
      },
      cookies: {
        title: "10. Cookies",
        intro: 'We use "cookies" to improve user experience:',
        items: ["Authentication and security", "Saving your preferences", "Session management"],
        management:
          "You can manage or block cookies through your browser settings, although this may limit the platform's functionality.",
      },
      childrenPrivacy: {
        title: "11. Protection of Minors",
        content:
          "OrderFlow is a business tool (B2B). We do not knowingly process personal data of individuals under 18 years of age. If we discover that a minor's data has entered the system, it will be immediately deleted.",
      },
      dataBreaches: {
        title: "12. Data Breaches",
        content:
          "In the event of an incident that threatens your rights, we undertake to notify you and the relevant supervisory authority within 72 hours of detecting the breach.",
      },
      changesToPolicy: {
        title: "13. Policy Changes",
        content:
          "OrderFlow reserves the right to update this policy. You will be notified of significant changes via email or through platform notifications.",
      },
      contact: {
        title: "14. Contact Information",
        intro: "For any questions regarding personal data, please contact us:",
        email: "Email: info@orderflow.ge",
        phone: "Phone: +995 505 051 685",
        dpo: "Data Protection Officer:",
        dpoEmail: "Email: info@orderflow.ge",
        supervisoryAuthority: "Supervisory Authority:",
        authority: "Personal Data Protection Service of Georgia",
        authorityWebsite: "Website: personaldata.ge",
        authorityEmail: "Email: office@personaldata.ge",
      },
      acknowledgment: "By using OrderFlow, you acknowledge that you have read and understood this Privacy Policy.",
    },
  },
  termsOfService: {
    title: "Terms of Service",
    lastUpdated: "Last Updated: 15.11.2025",
    backToHome: "Back to Home",
    sections: {
      agreementToTerms: {
        title: "1. Agreement to Terms",
        content:
          "By accessing or using OrderFlow, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our service.",
      },
      descriptionOfService: {
        title: "2. Description of Service",
        content:
          "OrderFlow provides an AI-powered order management platform that helps Georgian businesses process orders from messaging apps (Viber, WhatsApp, Telegram). The service includes order extraction, customer management, analytics, and data export features.",
      },
      accountRegistration: {
        title: "3. Account Registration",
        items: [
          "You must be at least 18 years old to use OrderFlow",
          "You must provide accurate and complete registration information",
          "You are responsible for maintaining the security of your account",
          "One account per business entity is permitted",
          "We reserve the right to approve or reject registrations",
        ],
      },
      subscriptionAndPayment: {
        title: "4. Subscription and Payment",
        plansAndPricing: {
          title: "Plans and Pricing (in Georgian Lari - ₾)",
          items: [
            "Starter: ₾49/month - Up to 100 orders, 1 user",
            "Professional: ₾149/month - Up to 500 orders, 3 users",
            "Business: ₾399/month - Unlimited orders, 10 users",
            "Enterprise: Custom pricing",
          ],
        },
        paymentTerms: {
          title: "Payment Terms",
          items: [
            "14-day free trial (no credit card required)",
            "Billing in advance on monthly or annual basis",
            "Annual plans receive 20% discount",
            "Payments are non-refundable except as required by law",
          ],
        },
      },
      acceptableUse: {
        title: "5. Acceptable Use",
        youMay: {
          title: "You May:",
          items: [
            "Use OrderFlow for legitimate business purposes",
            "Process genuine customer orders",
            "Generate business insights",
            "Export your data",
          ],
        },
        youMayNot: {
          title: "You May Not:",
          items: [
            "Use OrderFlow for illegal activities",
            "Process fraudulent transactions",
            "Attempt to reverse-engineer our technology",
            "Resell or sublicense the service",
            "Violate any applicable laws or regulations",
            "Store prohibited or harmful content",
          ],
        },
      },
      intellectualProperty: {
        title: "6. Intellectual Property",
        items: [
          "You retain ownership of your business data",
          "OrderFlow retains all rights to our software, AI models, and branding",
          "You grant us a license to process your data to provide the service",
          "Any feedback you provide becomes our property",
        ],
      },
      dataProcessing: {
        title: "7. Data Processing",
        items: [
          "We process data according to our Privacy Policy",
          "AI extraction is approximately 95% accurate - human review recommended",
          "You are responsible for the accuracy of final data",
          "We use Google Gemini for AI processing",
          "Data may be processed internationally with appropriate safeguards",
        ],
      },
      serviceAvailability: {
        title: "8. Service Availability",
        items: [
          "We target 99.9% uptime (excluding maintenance)",
          "Support available Monday-Friday, 9:00-18:00 Tbilisi time",
          "We may modify or discontinue features with notice",
          "Scheduled maintenance will be announced in advance",
        ],
      },
      limitationOfLiability: {
        title: "9. Limitation of Liability",
        items: [
          "Our liability is limited to the amount paid in the 12 months before any claim",
          "We are not liable for indirect, incidental, or consequential damages",
          "We are not liable for lost profits or data loss",
          "These limitations don't apply to gross negligence or willful misconduct",
        ],
      },
      warranties: {
        title: "10. Warranties and Disclaimers",
        content:
          'THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR COMPLETELY SECURE.',
      },
      indemnification: {
        title: "11. Indemnification",
        intro: "You agree to indemnify and hold OrderFlow harmless from any claims arising from:",
        items: [
          "Your use of the service",
          "Your violation of these terms",
          "Your violation of any rights of another party",
          "Your content or data",
        ],
      },
      termination: {
        title: "12. Termination",
        items: [
          "You may cancel your subscription at any time",
          "We may terminate accounts that violate these terms",
          "Upon termination, you have 30 days to export your data",
          "After 30 days, your data will be permanently deleted",
        ],
      },
      changesToTerms: {
        title: "13. Changes to Terms",
        intro: "We may modify these terms at any time. Material changes will include:",
        items: [
          "30-day advance notice via email",
          "Opportunity to export data before changes take effect",
          "Continued use constitutes acceptance of new terms",
        ],
      },
      governingLaw: {
        title: "14. Governing Law",
        content:
          "These Terms are governed by the laws of Georgia. Any disputes shall be resolved in the courts of Tbilisi, Georgia.",
      },
      privacyAndDataProtection: {
        title: "15. Privacy and Data Protection",
        content:
          "By using OrderFlow, you agree to our Privacy Policy. We process personal data in compliance with GDPR and Georgian Personal Data Protection Law.",
      },
      exportControl: {
        title: "16. Export Control",
        content: "You agree to comply with all applicable export and import laws and regulations.",
      },
      entireAgreement: {
        title: "17. Entire Agreement",
        content: "These Terms and our Privacy Policy constitute the entire agreement between you and OrderFlow.",
      },
      severability: {
        title: "18. Severability",
        content:
          "If any provision of these Terms is found to be unenforceable, the remaining provisions will continue in full effect.",
      },
      contact: {
        title: "19. Contact Information",
        generalSupport: "General Support:",
        email: "Email: support@orderflow.ge",
        phone: "Phone: +995 XXX XXX XXX",
        legalInquiries: "Legal Inquiries:",
        legalEmail: "Email: legal@orderflow.ge",
        address: "Address:",
        addressLine1: "[Your Company Name]",
        addressLine2: "[Street Address]",
        addressLine3: "[Postal Code] Tbilisi, Georgia",
      },
      acknowledgment:
        "By using OrderFlow, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.",
    },
  },
  cookieConsent: {
    message:
      "We use essential cookies to provide our services, including authentication and preferences. By continuing, you agree to our use of cookies.",
    acceptAll: "Accept All",
    rejectNonEssential: "Reject Non-Essential",
    learnMore: "Learn More",
    essentialOnly: "Essential Only",
  },
  resetPassword: {
    title: "Set Your New Password",
    description: "Please choose a secure password for your account.",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updateButton: "Update Password",
    updating: "Updating...",
    successMessage: "Password updated successfully!",
    errorPasswordsMismatch: "Passwords do not match",
    errorPasswordTooShort: "Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and a digit",
    errorGeneric: "Password couldn't be updated. Let's try again.",
    cancelled: "Cancelled",
    cancelledDescription: "Password reset cancelled. You've been signed out.",
  },
  forcePasswordChange: {
    title: "Password Change Required",
    description: "For security reasons, you must set a new password before continuing.",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updateButton: "Update Password",
    updating: "Updating...",
    successMessage: "Password updated successfully!",
    errorPasswordsMismatch: "Passwords do not match",
    errorPasswordTooShort: "Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and a digit",
    errorGeneric: "Password couldn't be updated. Let's try again.",
  },
  admin: {
    layout: {
      title: "Admin Panel",
      users: "Users",
      applications: "Applications",
      statistics: "Statistics",
      history: "History",
      customers: "Customers",
      settings: "Settings",
      menu: "Menu",
      signOut: "Sign Out",
      viewOrders: "View Orders",
    },
    customerActivity: {
      title: "Customer Activity",
      description: "Aggregated business metrics for active customers (GDPR-safe, no personal data)",
      search: "Search by name or company...",
      noData: "No active customers found",
      metrics: {
        activeCustomers: "Active Customers",
        totalRevenue: "Total Revenue",
        totalOrders: "Total Orders",
      },
      sort: {
        revenue: "Revenue",
        orders: "Orders",
        recent: "Recent",
        lastActivity: "Last Activity",
      },
      table: {
        business: "Business",
        revenue: "Revenue",
        orders: "Orders",
        recent30: "Last 30 Days",
        successRate: "Success Rate",
        deliveryLinks: "Delivery Links",
        lastOrder: "Last Order",
        status: "Status",
      },
      status: {
        active: "Active",
        trial: "Trial",
        expired: "Expired",
      },
      hide: "Hide from list",
      unhide: "Show in list",
      showHidden: "Show hidden",
      hideHidden: "Hide filtered",
    },
    statistics: {
      title: "Statistics & Analytics",
      description: "Monitor user engagement and demo performance",
      userEngagement: {
        title: "User Engagement Overview",
        totalUsers: "Total Users",
        neverLoggedIn: "Never Logged In",
        noOrders: "No Orders Yet",
        activeRecently: "Active (7 days)",
        atRisk: "At Risk (14+ days)",
        table: {
          user: "User",
          lastLogin: "Last Login",
          orders: "Orders",
          status: "Status",
          never: "Never",
          noUsers: "No users found",
          statusActive: "Active",
          statusAtRisk: "At Risk",
          statusNever: "Never Logged In",
          statusNoOrders: "No Orders",
        },
      },
    },
    demoStats: {
      title: "Demo Widget Statistics",
      totalDemos: "Total Demos",
      successRate: "Success Rate",
      avgTime: "Avg Time",
      today: "Today",
      conversions: "Conversions",
    },
    users: {
      title: "User Management",
      description: "Manage approved users and their roles",
      search: "Search by name, email, or company...",
      refresh: "Refresh",
      inviteUser: "Invite User",
      recentInvitations: "Recent Invitations",
      noInvitations: "No invitations sent yet",
      noInvitationsDesc: "New invitations will appear here",
      loadingUsers: "Loading users...",
      noUsersMatch: "No users match your search",
      filters: {
        all: "All",
        active: "Active",
        deactivated: "Deactivated",
      },
      stats: {
        total: "Total Users",
        active: "Active Users",
        deactivated: "Deactivated",
        admins: "Admins",
      },
      table: {
        name: "Name",
        email: "Email",
        company: "Company",
        businessType: "Business Type",
        role: "Role",
        status: "Status",
        invitationStatus: "Invitation",
        joined: "Joined",
        actions: "Actions",
        noUsers: "No users found",
        noRole: "No Role",
        noName: "No Name",
      },
      status: {
        active: "Active",
        deactivated: "Deactivated",
      },
      invitationStatus: {
        accepted: "Accepted",
        pending: "Pending",
        not_invited: "Not Invited",
      },
      invitationDetails: {
        title: "Invitation Details",
        status: "Invitation Status",
        invitedDate: "Invited Date",
        acceptedDescription: "User has accepted the invitation and logged in",
        pendingDescription: "Invitation sent, awaiting user action",
        notInvitedDescription: "User registered directly without invitation",
      },
      businessTypes: {
        retail: "Retail",
        restaurant: "Restaurant/Cafe",
        wholesale: "Wholesale",
        ecommerce: "E-commerce",
        service: "Service",
        other: "Other",
      },
      actions: {
        manageFeatures: "Manage Features",
        resendInvite: "Resend Welcome Email",
        resendApproval: "Resend Approval Email",
        changeRole: "Change Role",
        deactivate: "Deactivate User",
        reactivate: "Reactivate User",
        delete: "Delete User",
      },
    },
    features: {
      title: "Manage Features",
      externalOrder: {
        title: "External Order Intake",
        description: "Allow this user to receive orders via a public link. Customers can place orders without an account.",
      },
      customersModule: {
        title: "Customers Module",
        description: "Enable customer tracking with order history, revenue stats, and delivery addresses.",
      },
      enabledSuccess: "Feature settings saved",
      disabledSuccess: "Feature disabled successfully",
      saveFailed: "Feature settings couldn't be saved",
    },
    applications: {
      title: "Access Applications",
      description: "Review and approve new user registrations",
      search: "Search applications...",
      refresh: "Refresh",
      filters: {
        all: "All",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
      table: {
        applicant: "Applicant",
        email: "Email",
        company: "Company",
        businessType: "Business Type",
        status: "Status",
        date: "Applied",
        actions: "Actions",
        noApplications: "No applications found",
      },
      status: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
      actions: {
        review: "Review",
      },
    },
    reviewModal: {
      title: "Review Application",
      approve: "Approve Application",
      reject: "Reject Application",
      approving: "Approving...",
      rejecting: "Rejecting...",
      cancel: "Cancel",
      rejectionReason: "Rejection Reason",
      rejectionPlaceholder: "Please provide a reason for rejection...",
      rejectionRequired: "Rejection reason is required",
      applicantInfo: "Applicant Information",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      company: "Company Name",
      businessType: "Business Type",
      referral: "How did you hear about us?",
      message: "Additional Message",
      status: "Current Status",
      appliedDate: "Applied Date",
      businessTypes: {
        retail: "Retail Store",
        restaurant: "Restaurant/Cafe",
        wholesale: "Wholesale",
        ecommerce: "E-commerce",
        service: "Service Business",
        other: "Other",
      },
      statuses: {
        pending: "Pending Review",
        approved: "Approved",
        rejected: "Rejected",
      },
    },
    deactivateDialog: {
      title: "Deactivate User Account",
      description: "Are you sure you want to deactivate this user account? They will no longer be able to log in.",
      reactivateNote: "You can reactivate this account later if needed.",
      cancel: "Cancel",
      confirm: "Deactivate User",
      confirming: "Deactivating...",
    },
    deleteDialog: {
      title: "Delete User Account",
      description:
        "This will permanently delete the user account and all associated data. This action cannot be undone.",
      confirmInstruction: "Type DELETE to confirm:",
      confirmPlaceholder: "Type DELETE here",
      cancel: "Cancel",
      confirm: "Delete Permanently",
      confirming: "Deleting...",
    },
    inviteDialog: {
      title: "Invite New User",
      description: "Send an invitation email to add a new user to your organization.",
      email: "Email Address",
      emailPlaceholder: "user@example.com",
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      company: "Company Name",
      companyPlaceholder: "Optional",
      personalMessage: "Personal Message",
      messagePlaceholder: "Add a personal welcome message (optional)",
      role: "Assign Role",
      language: "Invitation Language",
      submit: "Send Invitation",
      cancel: "Cancel",
      sending: "Sending...",
    },
    roles: {
      user: "User",
      userDescription: "Basic access to orders and features",
      manager: "Manager",
      managerDescription: "Can manage orders and view reports",
      admin: "Administrator",
      adminDescription: "Full access to all features and settings",
    },
    toasts: {
      inviteSuccess: "Invitation Sent! 🎉",
      inviteSuccessDesc: "Invitation email sent to",
      inviteError: "Invitation couldn't be sent",
      inviteErrorDesc: "Please try again or contact support if the problem persists.",
      resendSuccess: "Invitation Resent!",
      resendSuccessDesc: "A new invitation email has been sent.",
      resendError: "Couldn't resend invitation",
      roleChangeSuccess: "Role Updated!",
      roleChangeSuccessDesc: "User role has been updated successfully.",
      roleChangeError: "Role couldn't be updated",
      deactivateSuccess: "User Deactivated ✅",
      deactivateSuccessDesc: "The user account has been deactivated successfully.",
      deactivateError: "Couldn't deactivate this user",
      reactivateSuccess: "User Reactivated ✅",
      reactivateSuccessDesc: "The user can now log in again.",
      reactivateError: "Couldn't reactivate this user",
      deleteSuccess: "User Deleted ✅",
      deleteSuccessDesc: "The user has been permanently removed from the database.",
      deleteError: "Couldn't delete this user",
      approveSuccess: "Application Approved! ✅",
      approveSuccessDesc: "has been approved. They will receive a welcome email with login instructions.",
      approveError: "Approval didn't go through",
      rejectSuccess: "Application Rejected",
      rejectSuccessDesc: "The applicant has been notified of the rejection.",
      rejectError: "Rejection didn't go through",
      loadError: "Something went wrong",
      loadErrorDesc: "Couldn't load data",
      loadUserHistoryError: "Couldn't load user history",
      genericError: "Something went wrong. Let's try again.",
      rejectionReasonRequired: "Rejection Reason Required",
      rejectionReasonRequiredDesc: "Please provide a reason for rejecting this application.",
    },
    trial: {
      column: "Trial",
      title: "Manage Trial",
      currentStatus: "Current Status",
      status: {
        active: "Active",
        trial: "Trial",
        expired: "Expired",
        daysLeft: "days left",
        unknown: "Unknown",
      },
      actions: {
        manage: "Manage Trial",
        extend: "Extend trial by 7 days",
        activate: "Activate subscription",
        expire: "Mark as expired",
      },
      toasts: {
        extended: "Trial extended by 7 days",
        activated: "Subscription activated",
        expired: "Trial marked as expired",
        error: "Trial status couldn't be updated",
      },
    },
    userHistory: {
      title: "User History",
      description: "Complete audit trail of user lifecycle events and administrative actions",
      filters: "Filters",
      filtersDescription: "Search and filter user history events",
      searchPlaceholder: "Search by email, name, or company...",
      eventType: "Event Type",
      refresh: "Refresh",
      allEvents: "All Events",
      noEventsFound: "No history events found",
      pageOf: "Page {{current}} of {{total}}",
      performedBySystem: "System",
      performedByLabel: "By:",
      table: {
        timestamp: "Timestamp",
        user: "User",
        event: "Event",
        details: "Details",
        performedBy: "Performed By",
      },
      events: {
        created: "CREATED",
        invited: "INVITED",
        approved: "APPROVED",
        rejected: "REJECTED",
        deleted: "DELETED",
        deactivated: "DEACTIVATED",
        reactivated: "REACTIVATED",
        login: "LOGIN",
        password_changed: "PASSWORD CHANGED",
      },
    },
  },
  delivery: {
    mobileCard: {
      title: "Delivery sessions",
      activeDesc: "{count} active session(s)",
      noActiveDesc: "Create link to share with courier",
      createNew: "Create new session",
    },
    completed: "Completed",
    shareTitle: "Delivery Link",
    shareText: "Track deliveries here:",
    modeToggle: {
      orders: "Orders",
      delivery: "Delivery",
    },
    kpi: {
      sectionTitle: "Today's Delivery Status",
      ready: "Ready",
      outForDelivery: "Out for Delivery",
      failed: "Failed",
      deliveredToday: "Delivered Today",
    },
    statuses: {
      outForDelivery: "Out for Delivery",
      delivered: "Delivered",
      deliveryFailed: "Delivery Failed",
    },
    actions: {
      markDelivered: "Delivered",
      markOutForDelivery: "Out for Delivery",
      markFailed: "Failed",
      retryDelivery: "Retry Delivery",
      reportProblem: "Problem?",
      call: "Call",
      navigate: "Navigate",
      failed: "Failed",
    },
    callCustomer: "Call customer",
    failureReasons: {
      customerNotHome: "Customer not home",
      wrongAddress: "Wrong address",
      customerRefused: "Customer refused",
      cannotAccess: "Cannot access location",
      customerUnreachable: "Customer unreachable",
    },
    failureModal: {
      title: "Delivery Failed",
      description: "Please select a reason for the failed delivery",
      notifyHint: "This will notify the manager immediately",
      selectReason: "Select failure reason",
      additionalNotes: "Additional notes (optional)",
      notesPlaceholder: "Any additional details about the failed delivery...",
      confirm: "Mark as Failed",
    },
    groups: {
      other: "Other Areas",
    },
    warnings: {
      addressRequired: "Address required",
      addressRequiredDescription: "Please add an address to this order before marking it for delivery",
      noAddress: "No delivery address - add address before dispatching",
    },
    addressRequired: "Address required for delivery",
    nextUp: "Next Up",
    readySince: "Ready since",
    progress: "{delivered} of {total} delivered",
    problemReported: "Problem reported - we'll follow up",
    empty: {
      title: "All caught up!",
      description: "No orders waiting for delivery right now.",
    },
    deliveredToday: {
      title: "Delivered Today",
      deliveredAt: "Delivered at",
      noDeliveries: "No deliveries completed yet today",
    },
    messages: {
      markedOutForDelivery: "Order marked as Out for Delivery",
      markedDelivered: "Order marked as Delivered ✓",
      deliveryUndone: "Delivery status undone",
      markedFailed: "Order marked as Delivery Failed",
      failedUndone: "Failed status undone",
      retryDelivery: "Order marked for retry delivery",
      markOutForDeliveryError: "Failed to mark order as Out for Delivery",
      markDeliveredError: "Failed to mark order as Delivered",
      markFailedError: "Failed to mark order as Failed",
      updateStatusError: "Failed to update delivery status",
    },
    activeLinks: "Active Deliveries",
    // Link generation
    generateLink: "Start Delivery",
    generateLinkShort: "Create a shareable delivery link",
    generateLinkDescription: "Create a delivery link to share with your courier",
    linkDuration: "Link Duration",
    includeOrders: "Include Orders",
    readyOrders: "Ready Orders",
    readyOrdersDesc: "Orders completed and ready for pickup",
    outForDeliveryOrders: "Out for Delivery Orders",
    outForDeliveryOrdersDesc: "Orders already dispatched",
    generate: "Create Delivery",
    endOfDay: "End of Day",
    unlimited: "Unlimited",
    unlimitedDesc: "No expiration - link stays active until closed",
    noOrdersWarning: "No orders are ready for delivery. Mark orders as 'Ready' first.",
    allOrdersAssigned: "All ready orders are already assigned to active sessions.",
    selectOrdersHint: "Select orders to include in delivery",
    linkGenerated: "Delivery created",
    ordersIncluded: "orders included",
    linkReady: "Delivery link is ready to share",
    deliveryLink: "Delivery Link",
    linkCopied: "Link copied to clipboard",
    expiresIn: "Expires",
    hours: "hours",
    noOrdersForLink: "No orders match the selected criteria",
    // Active link banner
    link: {
      active: "Active Delivery",
      expired: "Expired",
      copy: "Copy",
      revoke: "Close Delivery",
      revokeTitle: "Close Delivery?",
      revokeWarning:
        "This will immediately close the delivery. Courier will no longer be able to access orders or mark them as delivered.",
      revoked: "Delivery closed",
      revokedDescription: "The delivery has been deactivated",
      revokeError: "Failed to close delivery",
      openExternal: "Open link in new tab",
    },
    // Sharing
    share: {
      button: "Dispatch",
      copyLink: "Copy Link",
      more: "More Options...",
      title: "Delivery Link",
      messagePrefix: "Delivery link",
      orders: "orders",
    },
    // Label
    labelInput: "Courier / Route Name (optional)",
    labelPlaceholder: "e.g., Giorgi, Morning Route",
    // Order preview
    preview: {
      title: "Orders Preview",
      noOrders: "No orders match the selected criteria",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      selected: "selected",
    },
    deactivate: {
      title: "Close Delivery",
      description: "Are you sure you want to close this delivery? The courier will no longer be able to access the orders.",
      cancel: "Cancel",
      confirm: "Close Delivery",
      confirming: "Closing...",
      message: "undelivered orders remain",
      reassign: "Move orders to another delivery",
      recommended: "Recommended",
      reassignDesc: "Transfer undelivered orders to another active delivery before closing",
      selectSession: "Select target delivery",
      selectSessionRequired: "Please select a target delivery",
      noOtherSessions: "No other active deliveries available",
      keepActive: "Keep delivery active",
      keepActiveDesc: "Don't close the delivery yet, keep it running",
      advancedOptions: "Advanced options",
      forceClose: "Force close",
      forceCloseDesc: "Close delivery immediately. Undelivered orders will become unassigned.",
      confirmReassign: "Move and close",
      reassignSuccess: "Delivery closed",
      ordersReassigned: "orders moved to new delivery",
      forceCloseSuccess: "Delivery force closed",
      forceCloseSuccessDesc: "Undelivered orders are now unassigned",
      thisSession: "this delivery",
      forceCloseWarningTitle: "Force close delivery?",
      forceCloseWarning: "orders will become unassigned and need to be re-dispatched",
      confirmForceClose: "Force Close",
    },
    // KPI bar
    outForDelivery: "Out for Delivery",
    activeSessions: "Active Deliveries",
    // Session management
    remaining: "remaining",
    active: "Active",
    defaultLabel: "Delivery",
    openLink: "Open link",
    pending: "Pending",
    statusDropdown: {
      inTransit: "In transit",
    },
    endSession: "Close Delivery",
    noActiveSessions: "No Active Deliveries",
    noActiveSessionsDesc: "Create a delivery to dispatch orders to your couriers",
    createSession: "Start Delivery",
    // Card labels
    total: "Total",
    delivered: "Delivered",
    progressLabel: "Progress",
    // Loading Manifest
    manifest: {
      title: "Loading Manifest",
      pickingSummary: "Picking Summary",
      pickingSummaryDesc: "Total items to pick from warehouse",
      loadingChecklist: "Loading Checklist",
      loadingChecklistDesc: "Verify each order is loaded",
      ordersToLoad: "orders to load",
      allLoaded: "All orders loaded!",
      viewManifest: "View Manifest",
      hideManifest: "Hide Manifest",
      orderLoaded: "Loaded",
      noAddress: "No address",
      noItems: "No items",
      loadingOrders: "Loading orders...",
      noOrdersInSession: "No orders in this session",
      totalProducts: "Total Products",
      checkedOff: "checked off",
    },
    // History section
    history: {
      title: "Closed Runs",
      empty: "No closed runs yet",
      completed: "Completed",
      ended: "Ended",
      expired: "Expired",
      showHistory: "Show History",
      hideHistory: "Hide History",
      sessions: "runs",
      ordersDelivered: "delivered",
      duration: "Duration",
      delete: "Delete",
      deleteConfirm: "Delete this closed run? This action cannot be undone.",
    },
    // Run terminology (P5 Phase 3)
    runs: {
      activeRuns: "Active Runs",
      pausedRuns: "Paused Runs",
      closedRuns: "Closed Runs",
      noActiveRuns: "No Active Runs",
      noActiveRunsDesc: "Create a delivery run to dispatch orders to your couriers",
      noPausedRuns: "No paused runs",
      startRun: "Start Delivery",
      pauseRun: "Pause Run",
      resumeRun: "Resume Run",
      closeRun: "Close Run",
      copyLink: "Copy Link",
      openCourierView: "Open Courier View",
      runPaused: "Run paused",
      runResumed: "Run resumed",
      runClosed: "Run closed",
      pending: "pending",
      moreOrders: "more orders",
      noStops: "No stops in this run",
      noExpiry: "No expiry",
      expired: "Expired",
      pause: "Pause",
      resume: "Resume",
      close: "Close session",
      paused: "Paused",
    },
    noOrdersInSession: "No stops in this run",
  },
  todayBoard: {
    title: "Today's Workflow",
    needsAttention: {
      title: "Needs Attention",
      subtitle: "Unfinished work from previous days",
      ordersLabel: "orders",
      outForDelivery: "Out for Delivery",
      readyNotSent: "Ready (Not Sent)",
      newBacklog: "New (Backlog)",
      empty: "All caught up! No action needed.",
    },
    today: {
      title: "Today",
      empty: "No new orders today. Continue from Needs Attention.",
      emptyState: "No new orders today. Continue working from 'Needs Attention'.",
    },
    hideDelivered: "Hide delivered",
    lastDelivered: "last",
    delivered: "delivered",
    noDeliveriesYet: "no deliveries yet",
    labels: {
      newToday: "New",
      fromBacklog: "From Backlog",
    },
    todaysOrders: "Today's Orders",
    todayWorkflow: "Today's Workflow",
    todayDesc: "Active orders for today",
    workedOnToday: "Worked on today",
    showLess: "Show less",
    stages: {
      new: "New",
      ready: "Ready",
      outForDelivery: "On the Way",
      delivered: "Delivered",
      failed: "Failed/Cancelled",
    },
    statuses: {
      new: "New",
      ready: "Ready",
      outForDelivery: "On the Way",
      delivered: "Delivered",
    },
    actions: {
      process: "Mark Ready",
      sendOut: "Send for Delivery",
      markDelivered: "Delivered",
      confirmDelivered: "Confirm Delivered",
    },
    quickActions: {
      markStatus: "Mark Status...",
      delivered: "✅ Delivered",
      couldNotDeliver: "❌ Could Not Deliver",
      onHold: "⏸ Put On Hold",
      sendOut: "🚀 Send Out",
      process: "⚡ Process",
      cancel: "🗑️ Cancel",
      deliveredSuccess: "Order marked as delivered",
      failedSuccess: "Order marked as could not deliver",
      onHoldSuccess: "Order put on hold",
      sendOutSuccess: "Order sent out for delivery",
      processSuccess: "Order processed",
      cancelSuccess: "Order cancelled",
    },
    emptyState: "No orders at this stage",
    showMore: "+{{count}} more",
    more: "more",
    failed: "Failed",
    cancelled: "Cancelled",
    noProducts: "No products",
    orderLabel: "order",
    messages: {
      ready: "Order is ready for delivery",
    },
    unfinished: {
      title: "Unfinished from Previous Days",
      description: "These orders are still pending from earlier. Complete them to clear the backlog.",
      groups: {
        outForDelivery: "Out for Delivery",
        ready: "Ready (Not Sent)",
        backlog: "New (Backlog)",
      },
    },
    bulk: {
      select: "Select",
      cancel: "Done",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      markReady: "Mark Ready",
      sendOut: "Send Out",
      markDelivered: "Deliver",
      readySuccess: "Orders marked as ready",
      sendOutSuccess: "Orders sent out for delivery",
      deliverSuccess: "Orders marked as delivered",
    },
  },
  needsAttentionTable: {
    order: "Order",
    notes: "Notes",
    reason: "Reason",
    status: "Status",
    customer: "Customer",
    lastAction: "Last Action",
    sentOut: "Sent out",
    markedReady: "Marked ready",
    created: "Created",
    moreOrders: "more orders",
    fallbackOutForDelivery: "Not delivered yet",
    fallbackReady: "Awaiting dispatch",
    fallbackFailed: "Delivery failed - needs retry",
    fallbackAwaitingPayment: "Awaiting payment confirmation",
    fallbackNew: "Awaiting processing",
    // Short reason labels for Reason column
    stillOut: "Still out",
    notDispatched: "Not dispatched",
    failedDelivery: "Failed",
    awaitingPayment: "Payment pending",
    awaitingProcessing: "Awaiting processing",
    needsReview: "Review needed",
  },
  columns: {
    toggle: "Toggle columns",
    status: "Status",
    session: "Session",
    customer: "Customer",
    productsPrice: "Products / Price",
    deliveryLog: "Log",
    notes: "Notes",
    reason: "Reason",
    lastAction: "Last Action",
  },
  todayTable: {
    order: "Order",
    status: "Status",
    customer: "Customer",
    assignedTo: "Assigned To",
    customerComments: "Customer Comments",
    productsPrice: "Products / Price",
    deliveryLog: "Log",
    deliveryLogPlaceholder: "Add note...",
    clickToAdd: "Click to add note",
    notAssigned: "Not assigned",
    noLog: "No notes",
    manager: "Manager",
    courier: "Courier",
    system: "System",
    deliveredFallback: "✓ Delivered",
  },
  deliveryLog: {
    title: "Log",
    addNote: "Add note",
    placeholder: "Type a note...",
    emptyState: "No notes yet",
    roles: {
      manager: "Manager",
      courier: "Courier",
      system: "System",
    },
  },
  history: {
    title: "All Orders",
    ordersCount: "{{count}} orders",
    viewAll: "View all orders",
  },
  achievements: {
    // Surprise achievements (past-tense, celebrating - shown once with pulse)
    recordRevenue: "Record set. ₾{{amount}} logged.",
    biggestOrder: "₾{{amount}} - largest order recorded.",
    beatYesterday: "{{percent}}% above previous cycle.",
    perfectDay: "Full delivery cycle complete.",
    milestone: "Milestone reached: Order #{{count}}.",
    streak: "{{days}}-day operational streak.",
    // System-status ambient fallbacks (faint, non-intrusive)
    needAttention: "{{count}} require attention",
    ordersAwait: "{{count}} orders in queue",
    progressUpdate: "{{delivered}}/{{total}} complete",
    deliveredToday: "{{delivered}} completed today",
    completedRest: "{{count}} processed. Cycle ending.",
    // Time-based system status (ambient tone)
    morningFresh: "System Active. Initiating Day Cycle.",
    afternoonSteady: "Order flow is stable.",
    eveningRest: "Operation Complete. Night Mode Engaged.",
    nightSleep: "Operation Complete. Night Mode Engaged.",
  },
  // Day Status Bar - operational summary
  dayStatus: {
    today: "TODAY",
    plannedNoRisk: "{{count}} orders planned • 0 at risk",
    plannedWithRisk: "{{count}} orders planned • {{attention}} need attention",
    allClear: "All clear — ready for new orders",
    closure: "All orders for today are handled",
    closureSub: "Tomorrow is ready",
  },
  // Needs Attention empty state
  needsAttention: {
    allGood: "No issues right now",
  },
  // Public Delivery View - Three Section Architecture
  publicDelivery: {
    section: {
      activeWork: "Active Work",
      completedToday: "Completed Today",
      history: "History",
      historyFooter: "Showing last 100 deliveries",
    },
    groupBy: {
      auto: "Auto",
      area: "Area",
      status: "Status",
      none: "None",
    },
    menu: {
      groupBy: "Group by",
      expandCompleted: "Expand Completed Today",
      expandHistory: "Expand History",
      collapseCompleted: "Collapse Completed Today",
      collapseHistory: "Collapse History",
      refresh: "Refresh",
    },
    statusGroups: {
      ready: "Ready for Pickup",
      outForDelivery: "Out for Delivery",
      failed: "Delivery Failed",
    },
    emptyActive: "No active orders",
    emptyActiveDesc: "All orders have been delivered or there are no orders assigned.",
  },
  errors: {
    invalidLink: "Invalid Link",
    invalidLinkDesc: "This delivery link format is not valid.",
    loadError: "Error Loading",
    loadErrorDesc: "Failed to load delivery information. Please try again.",
    linkNotFound: "Link Not Found",
    linkNotFoundDesc: "This delivery link does not exist.",
    linkExpired: "Link Expired",
    linkExpiredDesc: "This delivery link has expired and is no longer available.",
    linkInactive: "Link Inactive",
    linkInactiveDesc: "This delivery link has been deactivated.",
  },
  actions: {
    retry: "Retry",
    refreshing: "Refreshing...",
    pullToRefresh: "Pull to refresh",
    markOutForDelivery: "Mark Out for Delivery",
    markDelivered: "Mark as Delivered",
    markFailed: "Mark as Failed",
  },
  planningRadar: {
    future: "Future",
    showFutureTooltip: "Show hidden future orders",
    hideFutureTooltip: "Hide future orders view",
    dueTomorrow: "Due Tomorrow",
    dueToday: "Due Today",
    overdue: "Overdue",
    hide: "Hide",
    unhide: "Show",
    orderHidden: "Order hidden from view",
    orderRevealed: "Order revealed",
    autoRevealed: "auto",
    requestedDelivery: "Requested Delivery",
    selectDate: "Select date",
    clearDate: "Clear date",
    noDate: "No date set",
    scheduledFor: "Scheduled",
    title: "Upcoming Deliveries",
    today: "Today",
    tomorrow: "Tomorrow",
    view: "View",
    noUpcoming: "No upcoming deliveries scheduled",
    moreOrders: "+{{count}} more",
    moreDates: "+{{count}} more dates",
  },
  pinnableWindow: {
    pinWindow: "Pin window",
    unpinWindow: "Unpin window",
    minimize: "Minimize to mini-view",
    expand: "Expand",
    openFullView: "Open in full view",
    close: "Close",
    resetPosition: "Reset position",
  },
  payment: {
    title: "Payment method",
    settingsTitle: "Payment Settings",
    settingsDesc: "Configure payment options for external orders",
    deliveryAndPayment: "Delivery & Payment",
    configureExternal: "Configure settings for external orders",
    deliveryFee: "Delivery Fee",
    addDeliveryFee: "Add delivery fee",
    addDeliveryDesc: "Add a delivery fee on top of order total",
    deliveryPrice: "Delivery price",
    freeDeliveryIf: "Free delivery if...",
    freeDeliveryNote: "Leave empty if no free delivery threshold",
    freeDeliveryPlaceholder: "Over 50₾",
    deliveryNote: "Delivery note",
    deliveryNotePlaceholder: "e.g., Tbilisi only",
    preview: "Will show:",
    deliveryLabel: "Delivery",
    free: "Free",
    enableBankTransfer: "Enable bank transfer",
    enableBankTransferDesc: "Allow customers to pay via bank transfer",
    enableBankDesc: "Let customers pay via bank transfer",
    enableCash: "Cash on delivery",
    enableCashDesc: "Allow customers to pay with cash on delivery",
    bankName: "Bank name",
    bankNamePlaceholder: "e.g., TBC Bank",
    iban: "IBAN",
    instructions: "Instructions (optional)",
    instructionsPlaceholder: "Additional instructions...",
    addBank: "Add Bank Account",
    maxBanks: "Maximum 4 bank accounts",
    bankRequired: "Bank name and IBAN are required",
    invalidIban: "Invalid IBAN format",
    duplicateIban: "This IBAN already exists",
    setDefault: "Set as default",
    defaultMethod: "Default method",
    cash: "Cash",
    cashOnDelivery: "Cash on Delivery",
    bank: "Bank",
    bankTransfer: "Bank Transfer",
    bankTransferDesc: "Transfer before delivery",
    transferAwaitingConfirm: "Bank Transfer — Awaiting confirmation",
    awaitingPayment: "Awaiting Payment",
    markAsPaid: "Mark as Paid",
    paymentReceived: "Payment received",
    confirmPayment: "Confirm Payment Received",
    confirmPaymentDesc: "Payment will be recorded and order status will change to New. Are you sure?",
    confirmReceived: "Confirm Payment",
    paymentMethod: "Payment Method",
    bankDetails: "Bank Details",
    reference: "Include order number in transfer description",
    orderTotal: "Order Total",
    atLeastOneMethod: "At least one payment method must be enabled",
  },
  trial: {
    banner: {
      daysRemaining: "{{days}} days remaining in your trial",
      hoursRemaining: "{{hours}} hours left in your trial",
      endsToday: "Your trial ends today",
      contactUs: "Questions?",
      contactCta: "Contact us",
      dismiss: "Dismiss",
    },
  },
  trialExpired: {
    title: "Your Trial Has Ended",
    description: "Thank you for trying OrderFlow. To continue managing your orders, please choose a plan that fits your business.",
    pricing: {
      perMonth: "month",
      popular: "Popular",
      starter: {
        name: "Starter",
        description: "Perfect for small businesses getting started",
        feature1: "Up to 100 orders/month",
        feature2: "1 user account",
        feature3: "Email support",
      },
      growth: {
        name: "Growth",
        description: "For growing businesses with more orders",
        feature1: "Unlimited orders",
        feature2: "Up to 5 user accounts",
        feature3: "Priority support",
        feature4: "Advanced analytics",
      },
    },
    contact: {
      title: "Ready to continue?",
      description: "Contact us to activate your subscription and keep your workflow running smoothly.",
      email: "Email Us",
      phone: "Call Us",
    },
    footer: "Made in Georgia 🇬🇪 with love",
  },
  businessInfo: {
    title: "Add your business info",
    description: "Help us personalize your experience",
    addInfo: "Add info",
    later: "Later",
    saved: "Business info saved",
    modalTitle: "Tell us about your business",
    modalDescription: "This helps us customize your experience",
    companyName: "Company name",
    companyNamePlaceholder: "Enter your company name",
    businessType: "Business type",
    selectType: "Select type",
    types: {
      bakery: "Bakery / Confectionery",
      restaurant: "Restaurant / Cafe",
      retail: "Retail / Shop",
      delivery: "Delivery Service",
      other: "Other",
    },
  },
  quickReply: {
    title: "Reply to Customer",
    orderLabel: "Order",
    template: "Template",
    channel: "Contact Method",
    messagePreview: "Message Preview",
    copyMessage: "Copy Message",
    copyPhone: "Copy Phone",
    copied: "Copied!",
    openWhatsApp: "Open WhatsApp",
    openViber: "Open Viber",
    openSMS: "Open SMS",
    callCustomer: "Call Customer",
    noPhone: "Customer phone missing",
    viberHint: "If Viber doesn't open, copy message and paste manually",
    mobileOnly: "Available on mobile",
    invalidPhoneHint: "Phone format is invalid",
    useCopyFallback: "Use the copy buttons below instead",
    preferred: "Preferred",
    didYouSend: "Did you send it?",
    markAsSent: "Mark as Sent",
    markedAsSent: "Marked as sent",
    resetToTemplate: "Reset to template",
    menuItem: "Quick Reply",
    channels: {
      whatsapp: "WhatsApp",
      viber: "Viber",
      sms: "SMS",
      call: "Call",
    },
    templates: {
      orderConfirmed: "Order Confirmed",
      paymentRequired: "Payment Required",
      paymentConfirmed: "Payment Confirmed",
      outForDelivery: "Out for Delivery",
      delivered: "Delivered",
      needsClarification: "Needs Clarification",
    },
    templateMessages: {
      orderConfirmed: "Hello {customerName}! Your order #{orderNumber} has been confirmed. We'll notify you when it's ready. Thank you! - {businessName}",
      paymentRequired: "Hello {customerName}! Your order #{orderNumber} is ready. Total: {total}₾. Please include reference #{orderNumber} when paying. - {businessName}",
      paymentConfirmed: "Hello {customerName}! Payment for order #{orderNumber} received. Your order is being prepared. Thank you! - {businessName}",
      outForDelivery: "Hello {customerName}! Your order #{orderNumber} is on the way! Our courier will arrive soon. - {businessName}",
      delivered: "Hello {customerName}! Your order #{orderNumber} has been delivered. Thank you for choosing us! - {businessName}",
      needsClarification: "Hello {customerName}! We have a question about your order #{orderNumber}. Please call us back. - {businessName}",
    },
  },
  preferredChannel: {
    title: "How should we contact you?",
    whatsapp: "WhatsApp",
    viber: "Viber",
    sms: "SMS",
    call: "Phone Call",
    hint: "We'll use this to send order updates",
  },
  customers: {
    overview: "Overview",
    phone: "Phone",
    internalNote: "Internal Note",
    searchPlaceholder: "Search by name or phone...",
    moduleDisabled: "Customers module is not enabled",
    emptyTitle: "No customers yet",
    emptyDesc: "Customers appear automatically when you receive orders.",
    noResults: "No customers found",
    noResultsDesc: "Try adjusting your search terms.",
    notFound: "Customer not found",
    ordersLabel: "orders",
    noDeliveredOrders: "No delivered orders yet",
    orderHistory: "Order History",
    lastAddress: "Last Address",
    recentAddresses: "Recent Addresses",
    tableHeaders: {
      namePhone: "Customer",
    },
    stats: {
      revenue: "Revenue",
      orders: "Orders",
      lastOrder: "Last Order",
      active: "Active",
      needsAttention: "Needs attention",
    },
    sections: {
      needsAttention: "Needs Attention",
      needsAttentionDesc: "No orders in 7+ days",
      active: "Active",
      activeDesc: "Ordered recently",
      top: "Top Customers",
      topDesc: "Highest revenue",
      all: "All Customers",
      allDesc: "Complete customer list",
      daysAgo: "{n}d ago",
    },
  },
};
